var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1067.4,
    height: 390.78,
    enableBackground: "new 0 0 3992 3928",
    viewBox: "0 0 10674 3907.8",
    xmlSpace: "preserve",
    id: "svg1240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1207"
  }, /*#__PURE__*/React.createElement("font", {
    id: "Teachers-Regular",
    horizAdvX: 504,
    horizOriginX: 0,
    "horiz-origin-y": 0,
    vertOriginX: 512,
    vertOriginY: 768,
    vertAdvY: 1024
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Teachers",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 800,
    descent: -200,
    xHeight: 440,
    capHeight: 680,
    bbox: "-115 -273 937 930",
    underlineThickness: 45,
    underlinePosition: -121,
    unicodeRange: "U+000D-F8FF",
    id: "font-face1"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 501,
    d: "M63 0v750h375v-750h-375zM125 63h250v625h-250v-625z",
    id: "missing-glyph1"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 501,
    d: "M63 0v750h375v-750h-375zM125 63h250v625h-250v-625z",
    id: "glyph1"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0,
    id: "glyph2"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333,
    id: "glyph3"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    unicode: " ",
    horizAdvX: 0,
    id: "glyph4"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 270,
    id: "glyph5"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 257,
    d: "M103 203l-19 477h88l-19 -477h-50zM129 -10q-24 0 -41.5 16.5t-17.5 39.5t17.5 40t41.5 17q23 0 40.5 -16.5t17.5 -39.5q0 -24 -17.5 -40.5t-40.5 -16.5z",
    id: "glyph6"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 367,
    d: "M235 428l-18 252h86l-17 -252h-51zM71 428l-17 252h86l-18 -252h-51z",
    id: "glyph7"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 566,
    d: "M163 -2l-61 7l23 200h-101v58h112l22 171h-105v58h114l22 195l60 -7l-22 -188h154l23 195l60 -7l-22 -188h100v-58h-108l-21 -171h100v-60h-110l-23 -205l-60 7l22 198h-155zM197 263h155l20 171h-153z",
    id: "glyph8"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 590,
    d: "M304 -13q-75 0 -131.5 21t-91 61.5t-44.5 97.5h89q6 -34 26.5 -58t59 -37t98.5 -15q38 0 70 9t56 25t37.5 38.5t13.5 49.5q0 30 -16.5 51.5t-41 35.5t-49.5 22.5t-41 12.5l-55 14q-37 10 -77 22.5t-74 32.5t-55 52.5t-21 81.5q0 61 32.5 102.5t89 63t128.5 21.5 q69 0 116 -21t74.5 -56.5t36.5 -79.5h-80q-8 47 -49 68.5t-97 21.5q-50 0 -89 -11.5t-61.5 -34.5t-22.5 -60q0 -39 22 -63.5t56 -39t71 -24.5l55 -13q47 -11 88 -26.5t72 -37.5t48.5 -53t17.5 -73q0 -96 -69.5 -148.5t-191.5 -52.5zM277 -70v820h72v-820h-72z",
    id: "glyph9"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 721,
    d: "M138 0l373 680h74l-375 -680h-72zM547 -10q-30 0 -54.5 11t-42 31t-26.5 45.5t-9 53.5q0 27 9 52.5t25.5 45.5t41.5 32t56 12q30 0 54.5 -11.5t41.5 -31.5t26 -45.5t9 -53.5q0 -27 -8.5 -52.5t-25.5 -45.5t-41 -31.5t-56 -11.5zM547 45q33 0 50 23.5t17 52.5 q0 24 -5 46.5t-19 36.5t-43 14q-25 0 -39.5 -11.5t-21 -31.5t-6.5 -44q0 -39 16.5 -62.5t50.5 -23.5zM174 406q-31 0 -55.5 11.5t-41.5 31.5t-25.5 45.5t-8.5 52.5q0 28 9 53.5t26 45.5t41.5 31.5t54.5 11.5q32 0 56.5 -12t41 -32t25.5 -45.5t9 -52.5q0 -28 -9 -53 t-26.5 -45t-42 -31.5t-54.5 -11.5zM174 461q34 0 50.5 24t16.5 51q0 22 -4 44.5t-18 38t-44 15.5q-22 0 -37.5 -10.5t-23 -27.5t-7.5 -38q0 -40 13.5 -68.5t53.5 -28.5z",
    id: "glyph10"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 689,
    d: "M268 -12q-65 0 -110.5 27t-69 72t-23.5 98q0 50 24 92t73 78q14 10 28.5 20.5t29.5 21.5q-36 41 -54 78t-18 69q0 41 17.5 74t50.5 52.5t78 19.5q44 0 76.5 -18.5t50.5 -50.5t18 -72q0 -33 -19.5 -65.5t-58.5 -64.5q-10 -9 -20 -17l-20 -16l140 -179q8 8 16.5 18t22.5 28 t38 50l57 -38q-17 -23 -39.5 -51t-50.5 -61l117 -153l-92 -2l-74 97q-25 -25 -55.5 -49.5t-64 -41t-68.5 -16.5zM258 60q28 0 58 16t64 47q8 8 16.5 16t15.5 15l-149 191q-28 -21 -48.5 -37t-31.5 -27q-25 -25 -37 -47.5t-12 -43.5q0 -33 16.5 -62.5t44.5 -48.5t63 -19z M280 431q12 8 30.5 21.5t31.5 26.5q16 16 24 33t8 36q0 36 -24 57.5t-56 23.5q-17 1 -36 -6.5t-32 -25.5t-13 -51q0 -22 11 -44t33 -45q6 -7 12 -13t11 -13z",
    id: "glyph11"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 173,
    d: "M61 428l-17 252h86l-18 -252h-51z",
    id: "glyph12"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 308,
    d: "M177 -224q-27 39 -49 96.5t-38 125t-24.5 136.5t-8.5 129q0 83 13.5 171t40 170t65.5 146h68q-42 -71 -68.5 -155t-39 -170t-12.5 -163q0 -79 12.5 -164t38.5 -167.5t68 -154.5h-66z",
    id: "glyph13"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 308,
    d: "M65 -224q42 72 68.5 155.5t38.5 169t12 161.5q0 80 -13 166t-39.5 169.5t-67.5 152.5h68q56 -118 81 -215t31.5 -166.5t6.5 -104.5q0 -58 -8.5 -126.5t-24.5 -136.5t-38 -127t-49 -98h-66z",
    id: "glyph14"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 530,
    d: "M192 392l-70 51l114 111l-159 28l26 82l144 -76l-25 162h86l-25 -162l144 76l27 -82l-160 -28l114 -111l-70 -51l-73 141z",
    id: "glyph15"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 460,
    d: "M195 34v148h-147v69h147v148h70v-148h148v-69h-148v-148h-70z",
    id: "glyph16"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 232,
    d: "M70 -112l-29 38q15 11 34 31.5t24 41.5h-5q-21 0 -38 15.5t-17 40.5q0 16 8 29t21 20.5t29 7.5q31 0 47 -21t16 -59q0 -28 -12.5 -54.5t-33 -49t-44.5 -40.5z",
    id: "glyph17"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 410,
    d: "M38 194v58h335v-58h-335z",
    id: "glyph18"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 267,
    d: "M133 -10q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph19"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 538,
    d: "M43 -201l388 951h75l-388 -951h-75z",
    id: "glyph20"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 560,
    d: "M280 -9q-64 0 -108.5 31t-71 82.5t-38.5 113.5t-12 123q0 49 7.5 99t24 95t43 80t65 55.5t90.5 20.5t90.5 -20.5t65 -55.5t43 -80t24 -95t7.5 -99q0 -61 -12 -123t-38.5 -113.5t-70.5 -82.5t-109 -31zM277 62q42 0 72.5 26.5t51 68t30 90t9.5 91.5q0 49 -9.5 98.5 t-29 91.5t-50.5 67.5t-73 25.5t-72 -24.5t-49 -64t-28 -86t-9 -91.5q0 -31 3 -70t12.5 -78t26.5 -72t45.5 -53t69.5 -20z",
    id: "glyph21"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 287,
    d: "M148 0v609h-98v61l168 18v-688h-70z",
    id: "glyph22"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 615,
    d: "M63 0l352 355q15 15 25 32.5t15 37t5 40.5q0 43 -21 77.5t-57 55.5t-80 21q-46 0 -83 -24t-57 -61.5t-16 -79.5h-71q-3 68 28.5 121.5t85 84.5t116.5 31q61 0 113.5 -29.5t84.5 -80.5t32 -117q0 -31 -7.5 -59t-22 -53t-36.5 -47l-237 -235h310v-70h-479z",
    id: "glyph23"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 532,
    d: "M257 -10q-33 0 -63.5 8t-58 24.5t-49 43.5t-36.5 65l73 20q20 -43 57 -67t74 -24q65 0 108.5 37.5t43.5 101.5q0 62 -41.5 94.5t-107.5 32.5h-48v73h48q61 0 99.5 28t38.5 82q0 56 -40.5 86t-100.5 30q-34 0 -68 -18t-53 -56l-74 18q18 45 49 72t70 39t79 12 q54 0 101.5 -21.5t77 -62t29.5 -98.5q0 -48 -20.5 -84t-58.5 -59q45 -25 70.5 -67.5t25.5 -101.5q0 -65 -32 -112t-83.5 -71.5t-109.5 -24.5z",
    id: "glyph24"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 565,
    d: "M60 262v418h71v-379l-31 31h415v-70h-455zM343 0v680h71v-680h-71z",
    id: "glyph25"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 550,
    d: "M266 -12q-61 0 -114.5 30.5t-84.5 82.5l61 36q22 -37 59 -57.5t71 -20.5q55 0 92 23t56 59t19 74q0 42 -20.5 78t-54.5 58t-76 22q-31 0 -56.5 -8t-47.5 -24l-76 34l78 305h299v-70h-246l-46 -182q26 8 49.5 12t45.5 4q40 0 79.5 -15.5t72 -44.5t52 -70.5t19.5 -93.5 q0 -64 -30.5 -116.5t-83 -84t-117.5 -31.5z",
    id: "glyph26"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 528,
    d: "M264 -11q-63 0 -115 30t-83 81.5t-31 115.5q0 41 13 76.5t38 66.5l266 321h92l-208 -250l20 13q70 -3 123.5 -32t83.5 -78.5t30 -114.5t-30.5 -117t-82.5 -82t-116 -30zM265 59q45 0 80.5 21t56 56t20.5 77q0 44 -21 79.5t-56 57t-79 21.5q-40 0 -77 -19.5t-60 -54.5 t-23 -81q0 -44 22 -79.5t58.5 -56.5t78.5 -21z",
    id: "glyph27"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 487,
    d: "M82 0l281 636l18 -29h-351v70h427l-299 -677h-76z",
    id: "glyph28"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 526,
    d: "M263 -10q-46 0 -86.5 14t-71 41t-48 64.5t-17.5 84.5q0 53 31 100t83 75q-40 34 -60.5 70t-20.5 76t14.5 72.5t40.5 55.5t60.5 35.5t74.5 12.5q41 0 75.5 -12.5t60 -36t40 -56t14.5 -72.5q0 -39 -20 -75t-61 -70q53 -28 83.5 -75t30.5 -98q0 -47 -17 -85t-47.5 -65 t-71 -41.5t-87.5 -14.5zM263 57q43 0 77 20.5t54 53.5t20 71q0 40 -21 71.5t-55.5 49.5t-74.5 18t-74.5 -18t-55.5 -49.5t-21 -71.5q0 -38 20 -71t54 -53.5t77 -20.5zM263 398q51 0 84.5 33.5t33.5 79.5q0 49 -34.5 80.5t-83.5 31.5t-83.5 -31.5t-34.5 -80.5 q0 -46 33.5 -79.5t84.5 -33.5z",
    id: "glyph29"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 528,
    d: "M84 0l208 250l-20 -13q-70 3 -123.5 32t-83.5 79t-30 114q0 65 30.5 117t82.5 82t116 30q63 0 115 -30t83 -81.5t31 -115.5q0 -41 -12.5 -76.5t-38.5 -66.5l-266 -321h-92zM263 309q42 0 78.5 21t58.5 56t22 78q0 44 -22 79.5t-58 56.5t-79 21q-45 0 -80.5 -21t-56 -56 t-20.5 -77q0 -43 21 -79t56.5 -57.5t79.5 -21.5z",
    id: "glyph30"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 267,
    d: "M133 337q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5zM133 -10q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph31"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 267,
    d: "M108 -112l-29 38q15 11 34 31.5t24 41.5h-2q-23 0 -40.5 15.5t-17.5 40.5q0 16 8 29t21 20.5t29 7.5q31 0 47 -21t16 -59q0 -28 -12.5 -54.5t-33 -49t-44.5 -40.5zM133 337q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph32"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 516,
    d: "M471 -17l-426 211v71l426 211v-74l-382 -185v26l382 -185v-75z",
    id: "glyph33"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 460,
    d: "M67 277v69h325v-69h-325zM67 96v69h325v-69h-325z",
    id: "glyph34"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 516,
    d: "M45 -18v74l382 185v-26l-382 185v75l426 -211v-71z",
    id: "glyph35"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 497,
    d: "M211 203v105q0 37 15.5 67t52.5 58q23 17 39 28t25 18q11 8 18.5 21t7.5 25q0 36 -19 57t-47 30.5t-56 9.5t-56 -10t-47.5 -30.5t-22.5 -53.5h-71q8 78 62.5 120t133.5 42q52 0 96 -19t70.5 -56t26.5 -90q0 -37 -24 -66t-47 -46l-25 -17.5t-23 -17.5q-21 -17 -30 -34.5 t-9 -36.5v-104h-70zM248 -10q-24 0 -41.5 16.5t-17.5 39.5t17.5 40t41.5 17q23 0 40.5 -16.5t17.5 -39.5q0 -24 -17.5 -40.5t-40.5 -16.5z",
    id: "glyph36"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 720,
    d: "M373 -81q-69 0 -128 25.5t-103 71t-68 106.5t-24 133q0 79 28.5 137t76 96.5t104.5 57.5t114 19q54 0 107 -20.5t96 -58.5t68.5 -91.5t25.5 -118.5q0 -46 -12 -87.5t-34 -74t-52 -51t-66 -18.5q-34 0 -60 19.5t-38 48.5q-24 -23 -54 -37.5t-53 -14.5q-38 0 -65.5 20.5 t-42.5 56.5t-15 82q0 37 11.5 74.5t33.5 68.5t53 50t70 19q35 0 59.5 -20.5t40.5 -48.5q3 9 5.5 19.5t5.5 18.5l63 -8l-15 -47q-8 -24 -17.5 -56t-17 -65t-8 -61t10.5 -45.5t39 -17.5q26 0 49.5 22.5t38 62t14.5 89.5q0 54 -20.5 98t-55.5 75t-77.5 48t-87.5 17 q-48 0 -95 -15.5t-86.5 -47.5t-63 -80.5t-23.5 -113.5q0 -79 35 -144t96 -103.5t137 -38.5q19 0 40.5 4.5t45.5 13.5l12 -49q-26 -10 -49.5 -15t-48.5 -5zM305 120q18 0 48.5 16t47.5 45q0 14 8 44t15 55q-9 50 -32 74t-46 24q-25 0 -49 -24.5t-39.5 -62.5t-15.5 -78 q0 -51 20 -72t43 -21z",
    id: "glyph37"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313z",
    id: "glyph38"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 539,
    d: "M75 0v680h184q65 0 112 -19.5t72.5 -55t25.5 -84.5q0 -45 -18 -85.5t-62 -60.5q43 -11 71.5 -38t43.5 -64.5t15 -82.5q0 -57 -30 -99.5t-83 -66.5t-123 -24h-208zM145 67h158q65 0 105.5 37.5t40.5 98.5q0 37 -18.5 65.5t-49 45.5t-67.5 17h-169v-264zM145 401h134 q51 0 85.5 25.5t34.5 83.5q0 52 -35 77.5t-105 25.5h-114v-212z",
    id: "glyph39"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 739,
    d: "M384 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5z",
    id: "glyph40"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 648,
    d: "M75 0v680h178q70 0 133 -24t112 -68.5t77 -107t28 -140.5q0 -73 -27 -135.5t-74.5 -108t-111 -71t-137.5 -25.5h-178zM145 70h110q79 0 142 35t100.5 96t37.5 139q0 79 -37.5 139.5t-100.5 95.5t-142 35h-110v-540z",
    id: "glyph41"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404z",
    id: "glyph42"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 499,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-307h-70z",
    id: "glyph43"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 791,
    d: "M395 -8q-72 0 -135 27t-111.5 75t-76 112t-27.5 137q0 69 26.5 132t73 112t109 77.5t134.5 28.5q83 0 152 -31.5t119 -88t72 -131.5h-74q-32 83 -102.5 132t-159.5 49q-58 0 -109 -21.5t-89.5 -60t-60 -89t-21.5 -109.5q0 -58 21.5 -108.5t59.5 -89.5t89 -61t110 -22 q62 0 117 24t95.5 68t60.5 103h-276v61h354l-7 -42q-11 -64 -43 -116t-79.5 -89.5t-104 -58t-117.5 -20.5z",
    id: "glyph44"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 599,
    d: "M75 0v680h70v-306h309v306h70v-680h-70v304h-309v-304h-70z",
    id: "glyph45"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220z",
    id: "glyph46"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 381,
    d: "M158 -8q-19 0 -37.5 6t-34.5 15.5t-30 22t-26 25.5l41 58q9 -11 24 -25t32 -23.5t32 -9.5q22 0 39 6.5t29 20t18 34t6 48.5v510h70v-510q0 -61 -22.5 -100.5t-59.5 -58.5t-81 -19z",
    id: "glyph47"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 474,
    d: "M75 0v680h70v-319l229 319h90l-250 -340l250 -340h-90l-229 319v-319h-70z",
    id: "glyph48"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 468,
    d: "M75 0v680h70v-610h283v-70h-353z",
    id: "glyph49"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 783,
    d: "M10 0l149 682h27l206 -539l206 539h26l149 -682h-71l-106 484l-187 -480h-34l-188 480l-105 -484h-72z",
    id: "glyph50"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 602,
    d: "M75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70z",
    id: "glyph51"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5z",
    id: "glyph52"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 529,
    d: "M75 0v680h218q59 0 108 -25.5t78.5 -71.5t29.5 -108q0 -60 -29 -106.5t-77.5 -73t-109.5 -26.5h-148v-269h-70zM145 335h158q40 0 70.5 19t48 51.5t17.5 71.5q0 41 -16.5 71.5t-47 48t-72.5 17.5h-158v-279z",
    id: "glyph53"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 784,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM645 -3l-256 268h95l254 -268h-93zM394 62q59 0 109.5 21.5t89 60t60 89.5 t21.5 109t-21.5 108.5t-60 89t-89.5 60t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5z",
    id: "glyph54"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 544,
    d: "M75 0v680h218q61 0 110 -26.5t77.5 -73t28.5 -105.5q0 -58 -27 -103t-71.5 -71.5t-99.5 -30.5l209 -270h-94l-199 269h-82v-269h-70zM145 336h158q42 0 72.5 19.5t47 51.5t16.5 70q0 39 -16.5 69.5t-46.5 48.5t-73 18h-158v-277z",
    id: "glyph55"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 574,
    d: "M299 -13q-57 0 -101.5 10.5t-77 32t-53.5 54t-30 75.5h83q7 -36 28.5 -60t59 -36t91.5 -12q48 0 88 12.5t64.5 41.5t24.5 77q0 33 -21.5 56.5t-55 39t-69.5 26t-66 17.5q-52 12 -91 29t-65 39.5t-39 49.5t-13 60q0 48 17.5 84t48.5 60t72 35.5t87 11.5q50 0 89 -9 t68.5 -27.5t49 -46.5t28.5 -65h-76q-10 44 -49.5 66t-109.5 22q-42 0 -77 -12t-55.5 -37t-20.5 -64q0 -35 20 -59t51 -39t66.5 -25t66.5 -18q44 -11 83 -25.5t69 -35.5t47 -52t17 -76q0 -53 -20.5 -91t-56 -62t-80 -35.5t-92.5 -11.5z",
    id: "glyph56"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 520,
    d: "M225 2v614h-205v66h480v-66h-205v-614h-70z",
    id: "glyph57"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5z",
    id: "glyph58"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 637,
    d: "M300 3l-290 677h76l245 -577h-24l244 577h76l-289 -677h-38z",
    id: "glyph59"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 813,
    d: "M172 0l-147 680h72l112 -525l-18 2l200 520h32l199 -520l-18 -2l113 525h71l-146 -680h-34l-212 566h22l-212 -566h-34z",
    id: "glyph60"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 606,
    d: "M21 0l239 339l-240 341h87l196 -290l196 290h86l-239 -340l239 -340h-86l-196 290l-196 -290h-86z",
    id: "glyph61"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 605,
    d: "M268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70z",
    id: "glyph62"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 580,
    d: "M25 0l403 615h-382v65h509l-403 -615h386v-65h-513z",
    id: "glyph63"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 352,
    d: "M98 -213v963h181v-49h-115v-864h115v-50h-181z",
    id: "glyph64"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 538,
    d: "M432 -201l-389 951h75l388 -951h-74z",
    id: "glyph65"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 352,
    d: "M73 -213v50h115v864h-115v49h181v-963h-181z",
    id: "glyph66"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 585,
    d: "M59 343l182 336h103l183 -336h-77l-157 291l-157 -291h-77z",
    id: "glyph67"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 520,
    d: "M-10 -146v58h540v-58h-540z",
    id: "glyph68"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 236,
    d: "M110 750l-110 143h76l90 -143h-56z",
    id: "glyph69"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph70"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 560,
    d: "M306 -10q-36 0 -66.5 10.5t-55 30t-44.5 44.5v-75h-70v750h70v-385q29 38 70.5 61.5t95.5 23.5q62 0 110.5 -32.5t76 -84.5t27.5 -113q0 -60 -27.5 -112.5t-76 -85t-110.5 -32.5zM295 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph71"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 521,
    d: "M259 -10q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18z",
    id: "glyph72"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 560,
    d: "M254 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 97 -22t69 -63v385h70v-750h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM265 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5t-20 -79 q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph73"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5z",
    id: "glyph74"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 326,
    d: "M119 0v375h-99v65h99v177q0 47 14.5 76t45 43t77.5 14h30v-65h-40q-29 0 -43 -13t-14 -42v-190h107v-65h-107v-375h-70z",
    id: "glyph75"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 565,
    d: "M270 -250q-42 0 -77.5 15t-63 41t-44.5 59t-23 70h70q12 -52 52 -83.5t86 -31.5q44 0 79 21.5t55.5 57.5t20.5 79v96q-14 -20 -37.5 -39.5t-55 -32t-72.5 -12.5q-62 0 -111 32t-76.5 84.5t-27.5 113.5t27.5 113.5t76.5 84.5t111 32q41 0 73.5 -13.5t55.5 -33t36 -37.5v74 h70v-462q0 -63 -30 -114.5t-81 -82.5t-114 -31zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5q-43 0 -78.5 -22t-56 -58t-20.5 -80q0 -43 20.5 -79.5t56 -58.5t78.5 -22z",
    id: "glyph76"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M70 0v750h70v-386q21 36 55.5 60.5t83.5 24.5q55 0 91.5 -21.5t55 -60.5t18.5 -92v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -23t-48 -66.5t-15 -105.5v-184h-70z",
    id: "glyph77"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM115 516q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph78"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 235,
    d: "M122 516q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13zM15 -243q-33 0 -67.5 13t-62.5 45l46 50q12 -16 32.5 -28t39.5 -12q38 0 60 25t22 65v525h70v-524q0 -42 -18 -78.5t-49.5 -58.5t-72.5 -22z",
    id: "glyph79"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 416,
    d: "M70 0v750h70v-507l161 198h93l-181 -214l193 -227h-93l-173 211v-211h-70z",
    id: "glyph80"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 220,
    d: "M75 0v750h70v-750h-70z",
    id: "glyph81"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 758,
    d: "M70 2v440h70v-70q20 34 52 57t78 23q50 0 85 -20.5t54 -63.5q20 36 53 60t79 24q51 0 86 -21t53 -60t18 -94v-275h-70v275q0 31 -9 54.5t-28.5 37t-51.5 13.5q-27 0 -52.5 -14.5t-42.5 -38t-17 -52.5v-275h-70v275q0 31 -9 54.5t-28.5 37t-51.5 13.5q-37 0 -64.5 -22 t-43.5 -57t-20 -76v-225h-70z",
    id: "glyph82"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5t-15 -98.5v-184h-70z",
    id: "glyph83"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5z",
    id: "glyph84"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 560,
    d: "M70 -250v690h70v-75q29 38 70.5 61.5t95.5 23.5q62 0 110.5 -32.5t76 -84.5t27.5 -113q0 -60 -27.5 -112.5t-76 -85t-110.5 -32.5q-36 0 -66.5 10.5t-55 30t-44.5 44.5v-325h-70zM295 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph85"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 555,
    d: "M420 -70v145q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-510h-70zM532 -253q-25 0 -45.5 8t-35.5 22.5t-23 35t-8 44.5v79h70v-63q0 -19 3 -32t12.5 -19 t26.5 -6t29 14t20 26l49 -34q-19 -40 -47 -57.5t-51 -17.5zM265 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph86"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 326,
    d: "M70 0v440h70v-86q13 37 29.5 57.5t37.5 29t45 8.5q11 0 22.5 -2t21.5 -7v-91q-12 11 -25 16.5t-27 5.5q-32 0 -55.5 -22.5t-36 -57t-12.5 -71.5v-220h-70z",
    id: "glyph87"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 402,
    d: "M203 -13q-51 0 -87.5 15t-58.5 45.5t-30 75.5h74q8 -29 23 -46.5t36 -24.5t47 -7q48 0 72 18t24 54q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19 t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5z",
    id: "glyph88"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 339,
    d: "M135 0v375h-110v65h110v171h70v-171h109v-65h-109v-375h-70z",
    id: "glyph89"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21z",
    id: "glyph90"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 425,
    d: "M196 -1l-186 441h76l127 -327l126 327h76l-185 -441h-34z",
    id: "glyph91"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 724,
    d: "M197 1l-187 439h78l132 -339l124 317h36l124 -317l132 339h78l-185 -439h-47l-120 298l-118 -298h-47z",
    id: "glyph92"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 448,
    d: "M25 0l154 221l-154 219h89l110 -169l110 169h89l-154 -220l154 -220h-89l-110 171l-110 -171h-89z",
    id: "glyph93"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 445,
    d: "M46 -250l148 322l-184 368h80l141 -295l126 295h78l-304 -690h-85z",
    id: "glyph94"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 455,
    d: "M15 0l268 375h-251v65h385l-268 -375h281v-65h-415z",
    id: "glyph95"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 380,
    d: "M238 -250q-23 0 -40.5 9t-29.5 27t-18 43.5t-6 58.5v226q0 29 -20 47.5t-44 28.5v68q32 12 48 36t16 61v264q0 33 7.5 63t30 49t67.5 19l51 -1v-50q-28 6 -47 3.5t-28.5 -13t-9.5 -28.5v-313q0 -47 -22.5 -76.5t-62.5 -51.5q32 -15 58.5 -38t26.5 -66v-225 q0 -36 9.5 -58.5t28.5 -30.5t47 -2v-49z",
    id: "glyph96"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 290,
    d: "M118 -225v950h55v-950h-55z",
    id: "glyph97"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 380,
    d: "M107 -250l-27 1v49q29 -6 47.5 2t28 30.5t9.5 58.5v225q0 29 12.5 48t32 32.5t40.5 23.5q-40 22 -62.5 51.5t-22.5 76.5v313q0 18 -9.5 28.5t-28 13t-47.5 -3.5v50l51 1q46 0 68 -19t29.5 -49t7.5 -63v-264q0 -37 16 -61t48 -36v-68q-24 -10 -44 -28.5t-20 -47.5v-226 q0 -36 -10 -67.5t-37.5 -51t-81.5 -19.5z",
    id: "glyph98"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 526,
    d: "M128 635l-52 34q7 14 19 29.5t26.5 30t30 23.5t28.5 9q29 0 55.5 -11.5t51.5 -22.5t49 -11q10 0 20.5 6t20.5 18.5t20 30.5l53 -33q-9 -14 -22 -29t-28.5 -28.5t-31.5 -21.5t-33 -8q-24 0 -47.5 11t-47.5 22t-52 11q-10 0 -20 -6.5t-20 -20t-20 -33.5z",
    id: "glyph99"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\\xA0",
    horizAdvX: 270,
    id: "glyph100"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\\xA1",
    horizAdvX: 257,
    d: "M156 234l19 -477h-88l19 477h50zM130 447q24 0 41.5 -16.5t17.5 -39.5t-17.5 -40t-41.5 -17q-23 0 -40.5 16.5t-17.5 39.5q0 24 17.5 40.5t40.5 16.5z",
    id: "glyph101"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\\xA2",
    horizAdvX: 521,
    d: "M259 119q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18zM143 0l164 680h75l-164 -680h-75z",
    id: "glyph102"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\\xA3",
    horizAdvX: 528,
    d: "M146 319h-96v70h96v67q0 75 10 126t30.5 81t54 43t79.5 13h42v-70h-41q-27 0 -46 -7t-30.5 -27t-16.5 -58.5t-5 -100.5v-67h137v-70h-138v-187q2 -22 -6.5 -37t-23.5 -25h296v-70h-438v72q44 -1 70.5 15.5t25.5 59.5v172z",
    id: "glyph103"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\\xA5",
    horizAdvX: 605,
    d: "M134 298v57h335v-57h-335zM134 147v57h335v-57h-335zM268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70z",
    id: "glyph104"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\\xA7",
    horizAdvX: 407,
    d: "M203 188l4 58q32 0 53.5 8t32 24t10.5 40q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5 q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5zM208 -10q-62 0 -105 25.5t-58 93.5h75q7 -23 19 -36.5t30 -19t41 -5.5q30 0 55 13.5t25 44.5q0 32 -22 46t-46 21q-11 3 -34 8.5t-48 13t-44 16.5q-34 16 -51 42t-17 61 q0 49 23.5 79.5t63.5 45t87 14.5l-4 -58q-32 0 -53.5 -8t-32 -24t-10.5 -40q0 -21 17.5 -37t51.5 -27q15 -5 37.5 -11t46 -12.5t41.5 -15.5q32 -15 50 -38.5t18 -58.5q0 -45 -22 -74.5t-57.5 -44t-76.5 -14.5z",
    id: "glyph105"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\\xA8",
    horizAdvX: 471,
    d: "M312 750q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM150 750q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph106"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\\xA9",
    horizAdvX: 747,
    d: "M373 0q-67 0 -126 24.5t-104 67.5t-70.5 100t-25.5 123q0 35 11.5 77t36.5 84t63 76.5t91.5 55.5t123.5 21q36 0 79.5 -11t86.5 -34.5t79.5 -60.5t58.5 -88.5t22 -119.5q0 -52 -21 -107t-62 -102.5t-102 -76.5t-141 -29zM371 148q-46 0 -86 22t-64 60.5t-24 85.5 q0 48 23.5 86t63.5 60.5t87 22.5q28 0 52.5 -7t44.5 -20t36 -31t26 -39h-60q-18 22 -42.5 33t-56.5 11q-34 0 -60.5 -16.5t-42 -42.5t-15.5 -57q0 -27 14 -53.5t42 -44t69 -17.5q29 0 51.5 10.5t39.5 31.5h60q-13 -24 -30 -41.5t-36.5 -29.5t-42.5 -18t-49 -6zM373 61 q73 0 132.5 33.5t95 91t35.5 129.5t-35.5 129t-95 90.5t-132.5 33.5q-75 0 -134 -35t-93.5 -92.5t-34.5 -125.5q0 -69 34.5 -127t94 -92.5t133.5 -34.5z",
    id: "glyph107"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\\xAA",
    horizAdvX: 424,
    d: "M194 346q-46 0 -82.5 24t-57 63.5t-20.5 84.5t20.5 84.5t57 64t82.5 24.5q41 0 72 -18t53 -46v56h52v-330h-52v56q-15 -19 -33.5 -33.5t-41.5 -22t-50 -7.5zM203 398q33 0 59.5 16.5t41.5 44t15 59.5t-15 59.5t-41.5 44t-59.5 16.5q-34 0 -60.5 -16.5t-41.5 -44 t-15 -59.5t15 -59.5t41.5 -44t60.5 -16.5z",
    id: "glyph108"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\\xAB",
    horizAdvX: 636,
    d: "M567 27l-254 160v71l254 160v-76l-210 -132v26l210 -134v-75zM323 27l-254 160v71l254 160v-76l-210 -132v26l210 -134v-75z",
    id: "glyph109"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\\xAE",
    horizAdvX: 747,
    d: "M373 8q-72 0 -131.5 26t-103 71t-67 102t-23.5 118q0 66 25 123.5t70 100.5t104 67.5t126 24.5q36 0 79.5 -11t86.5 -35t79.5 -61t58.5 -89t22 -120q0 -52 -21 -107.5t-62 -103t-102 -77t-141 -29.5zM373 71q73 0 132.5 33.5t95 91t35.5 129.5t-35.5 129t-95 90.5 t-132.5 33.5q-75 0 -134 -35t-93.5 -92.5t-34.5 -125.5q0 -69 34.5 -127t94 -92.5t133.5 -34.5zM277 168v313h103q34 0 57 -10.5t35.5 -30t12.5 -48.5q0 -19 -13.5 -46.5t-48.5 -38.5l77 -139h-59l-63 131h-50v-131h-51zM328 345h48q27 0 43 12.5t16 34.5t-16 35t-43 13h-48 v-95z",
    id: "glyph110"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\\xAF",
    horizAdvX: 551,
    d: "M84 750v57h383v-57h-383z",
    id: "glyph111"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\\xB0",
    horizAdvX: 460,
    d: "M230 384q-47 0 -84.5 18.5t-59 52t-21.5 78.5q0 44 22 77.5t59.5 52.5t83.5 19t83 -18.5t59.5 -52t22.5 -78.5q0 -44 -21 -77.5t-58 -52.5t-86 -19zM230 438q22 0 43.5 7t36.5 27.5t15 59.5q0 34 -13.5 54.5t-35 30t-46.5 9.5q-31 0 -52.5 -12t-32 -33t-10.5 -49 q0 -31 10.5 -52t31.5 -31.5t53 -10.5z",
    id: "glyph112"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\\xB1",
    horizAdvX: 480,
    d: "M69 23v70h325v-70h-325zM202 129v148h-147v69h147v148h70v-148h148v-69h-148v-148h-70z",
    id: "glyph113"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\\xB4",
    horizAdvX: 246,
    d: "M20 750l80 134h76l-100 -134h-56z",
    id: "glyph114"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\\xB6",
    horizAdvX: 520,
    d: "M262 0v208q-60 9 -108.5 39t-77 77.5t-28.5 107.5q0 62 30.5 112.5t82 80.5t113.5 30h138v-655h-43v612h-63v-612h-44z",
    id: "glyph115"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\\xB7",
    horizAdvX: 267,
    d: "M133 176q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph116"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\\xB8",
    horizAdvX: 545,
    d: "M131 -231l25 52q22 -7 43.5 -11.5t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph117"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\\xBA",
    horizAdvX: 405,
    d: "M203 349q-48 0 -87 22.5t-62.5 61.5t-23.5 88q0 48 23 87t62.5 62t87.5 23t87 -23t62 -62t23 -87q0 -49 -23.5 -88t-62.5 -61.5t-86 -22.5zM203 401q33 0 60 16t43.5 43.5t16.5 60.5t-16.5 60t-43.5 43.5t-60 16.5q-34 0 -61 -16.5t-43 -43.5t-16 -60t16 -60.5 t43.5 -43.5t60.5 -16z",
    id: "glyph118"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\\xBB",
    horizAdvX: 630,
    d: "M312 27v75l210 134v-26l-210 132v76l254 -160v-71zM69 27v75l210 134v-26l-210 132v76l254 -160v-71z",
    id: "glyph119"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\\xBF",
    horizAdvX: 492,
    d: "M285 239v-105q0 -37 -15 -67t-53 -58q-22 -16 -38.5 -27t-25.5 -19q-10 -8 -18 -21t-8 -25q0 -35 19 -56.5t47.5 -31t55.5 -9.5q29 0 56.5 10t47 31t22.5 53h71q-7 -78 -62 -120t-134 -42q-52 0 -96 19t-70.5 56t-26.5 90q0 38 24.5 67t46.5 45q11 8 25.5 18t22.5 17 q21 17 30 34.5t9 36.5v104h70zM248 452q24 0 41.5 -16.5t17.5 -39.5t-17.5 -40t-41.5 -17q-23 0 -40.5 16.5t-17.5 39.5q0 24 17.5 40.5t40.5 16.5z",
    id: "glyph120"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\\xC0",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM275 722l-110 143h76l90 -143h-56z",
    id: "glyph121"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\\xC1",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM279 726l80 134h76l-100 -134h-56z",
    id: "glyph122"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\\xC2",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM167 729l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph123"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\\xC3",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM377 719q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5 t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph124"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\\xC4",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM389 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM227 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13 z",
    id: "glyph125"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\\xC5",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM315 710q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58q0 -46 -33 -77.5t-80 -31.5zM316 768q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5 t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph126"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\\xC6",
    horizAdvX: 826,
    d: "M10 0l359 680h397v-66h-315v-243h305v-65h-305v-241h315v-65h-385v175h-198l-93 -175h-80zM217 240h164v342l-7 -41z",
    id: "glyph127"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\\xC7",
    horizAdvX: 739,
    d: "M384 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5zM261 -252l25 52q22 -7 43.5 -11.5t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63 t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph128"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\\xC8",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM243 722l-110 143h76l90 -143h-56z",
    id: "glyph129"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\\xC9",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM247 726l80 134h76l-100 -134h-56z",
    id: "glyph130"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\\xCA",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM135 729l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph131"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\\xCB",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM357 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM195 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph132"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\\xCC",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM110 722l-110 143h76l90 -143h-56z",
    id: "glyph133"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\\xCD",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM114 726l80 134h76l-100 -134h-56z",
    id: "glyph134"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\\xCE",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM2 729l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph135"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\\xCF",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM224 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM62 733q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph136"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\\xD0",
    horizAdvX: 648,
    d: "M75 0v295h-67v57h67v328h178q72 0 135.5 -25t111.5 -70t75.5 -107.5t27.5 -137.5q0 -73 -27 -135.5t-74.5 -108t-111 -71t-137.5 -25.5h-178zM145 70h110q79 0 142 35t100.5 96t37.5 139q0 79 -37.5 139.5t-100.5 95.5t-142 35h-110v-258h178v-57h-178v-225z",
    id: "glyph137"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\\xD1",
    horizAdvX: 602,
    d: "M75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70zM349 712q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49 q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph138"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\\xD2",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM361 734l-110 143h76l90 -143h-56z",
    id: "glyph139"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\\xD3",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM365 738l80 134h76l-100 -134h-56z",
    id: "glyph140"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\\xD4",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM253 741l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph141"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\\xD5",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM463 731q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8 t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph142"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\\xD6",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM475 745q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM313 745q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5 t-13 -32t-32 -13z",
    id: "glyph143"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\\xD7",
    horizAdvX: 460,
    d: "M104 47l-49 49l125 126l-125 126l49 50l126 -126l126 126l49 -50l-125 -126l125 -126l-49 -49l-126 126z",
    id: "glyph144"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\\xD8",
    horizAdvX: 789,
    d: "M394 -8q-73 0 -131 26t-95 57l-44 -44l-39 39l44 44q-34 40 -59 98t-25 130q0 69 26 132t73.5 112t111 77t138.5 28q66 0 124 -22t104 -62l43 42l39 -39l-43 -42q41 -48 62 -105t21 -121q0 -76 -28.5 -140t-77.5 -111t-112 -73t-132 -26zM394 62q59 0 109.5 21.5t89 60 t60 89.5t21.5 109q0 50 -15.5 94t-46.5 82l-394 -393q38 -31 82 -47t94 -16zM179 164l394 393q-38 32 -83 48t-96 16q-58 0 -108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5q0 -51 16 -95.5t48 -82.5z",
    id: "glyph145"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\\xD9",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM278 708l-110 143h76l90 -143h-56z",
    id: "glyph146"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\\xDA",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM282 712l80 134h76l-100 -134h-56z",
    id: "glyph147"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\\xDB",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM170 715l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph148"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\\xDC",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM392 719q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z M230 719q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph149"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\\xDD",
    horizAdvX: 605,
    d: "M268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70zM273 718l80 134h76l-100 -134h-56z",
    id: "glyph150"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\\xDE",
    horizAdvX: 529,
    d: "M75 0v680h70v-100h148q59 0 108 -25.5t78.5 -71.5t29.5 -108q0 -59 -28.5 -106t-77.5 -73.5t-110 -26.5h-148v-169h-70zM145 235h158q41 0 71.5 19.5t47.5 51.5t17 71q0 40 -16.5 71t-47 48.5t-72.5 17.5h-158v-279z",
    id: "glyph151"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\\xDF",
    horizAdvX: 551,
    d: "M70 0v441q0 77 18 131.5t62 83.5t121 29q49 0 92 -19.5t69.5 -56t26.5 -88.5q0 -49 -26.5 -82.5t-63.5 -52.5q58 -22 100 -66.5t42 -114.5q0 -58 -30 -104.5t-79 -73.5t-107 -27h-66v67h66q38 0 71 19.5t53.5 52.5t20.5 73t-20.5 69.5t-53.5 46t-71 16.5h-34v62h10 q32 0 58 14t41 38t15 54q0 44 -32.5 74.5t-81.5 30.5q-57 0 -84.5 -24t-36 -69t-8.5 -108v-416h-72z",
    id: "glyph152"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\\xE0",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM242 493l-110 143h76l90 -143h-56z",
    id: "glyph153"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\\xE1",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM246 497l80 134h76l-100 -134h-56z",
    id: "glyph154"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\\xE2",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM134 500l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph155"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\\xE3",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM344 490q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5 t-57.5 -18z",
    id: "glyph156"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\\xE4",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM356 504q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM194 504q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph157"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\\xE5",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM282 481q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58q0 -46 -33 -77.5t-80 -31.5zM283 539q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph158"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\\xE6",
    horizAdvX: 927,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM668 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19 q31 0 57.5 7t49 21t40.5 36l53 -44q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5z",
    id: "glyph159"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\\xE7",
    horizAdvX: 521,
    d: "M259 -10q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18zM130 -242l25 52q22 -7 43.5 -11.5t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph160"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\\xE8",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM237 496l-110 143h76l90 -143h-56z",
    id: "glyph161"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\\xE9",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM241 500l80 134h76l-100 -134h-56z",
    id: "glyph162"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\\xEA",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM129 503l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph163"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\\xEB",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM351 507q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM189 507q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph164"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\\xEC",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM80 485l-110 143h76l90 -143h-56z",
    id: "glyph165"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\\xED",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM84 489l80 134h76l-100 -134h-56z",
    id: "glyph166"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\\xEE",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM-28 492l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph167"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\\xEF",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM194 496q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM32 496q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph168"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\\xF0",
    horizAdvX: 570,
    d: "M270 -7q-63 0 -115.5 27.5t-83.5 76t-31 110.5t31 110.5t83 76.5t116 28t116 -28t83 -76.5t31 -110.5t-31 -110.5t-83.5 -76t-115.5 -27.5zM270 63q44 0 80.5 18.5t58 51.5t21.5 74q0 42 -21.5 75t-57.5 51.5t-81 18.5q-44 0 -80.5 -18.5t-58 -51.5t-21.5 -75 q0 -41 21.5 -74t58 -51.5t80.5 -18.5zM256 480l-40 40l216 216l40 -40zM144 666v70q117 -8 197 -66t120.5 -172t38.5 -291h-70q-2 96 -17 177.5t-47.5 142t-86.5 97t-135 42.5z",
    id: "glyph169"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\\xF1",
    d: "M70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5t-15 -98.5v-184h-70zM334 487q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49 q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph170"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\\xF2",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM235 495l-110 143h76l90 -143h-56z",
    id: "glyph171"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\\xF3",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM239 499l80 134h76l-100 -134h-56z",
    id: "glyph172"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\\xF4",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM127 502l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph173"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\\xF5",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM337 492q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph174"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\\xF6",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM349 506q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM187 506q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph175"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\\xF7",
    horizAdvX: 460,
    d: "M62 188v70h335v-70h-335zM236 12q-23 0 -39 16t-16 39t16 39.5t39 16.5t39.5 -16.5t16.5 -39.5t-16.5 -39t-39.5 -16zM236 316q-23 0 -39 16t-16 39t16 39.5t39 16.5t39.5 -16.5t16.5 -39.5t-16.5 -39t-39.5 -16z",
    id: "glyph176"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\\xF8",
    horizAdvX: 550,
    d: "M82 -12l-39 39l52 52q-23 29 -36.5 65.5t-13.5 77.5q0 64 31 116t83 83t116 31q41 0 77.5 -13t65.5 -36l49 49l39 -39l-49 -49q23 -29 35.5 -65t12.5 -77q0 -64 -31 -116t-83.5 -82.5t-115.5 -30.5q-40 0 -76 12.5t-65 34.5zM275 63q44 0 80.5 21.5t58 57.5t21.5 80 q0 52 -28 91l-222 -222q19 -13 42 -20.5t48 -7.5zM145 129l223 224q-19 14 -43 21.5t-50 7.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -26 8 -49.5t22 -43.5z",
    id: "glyph177"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\\xF9",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM221 477l-110 143h76l90 -143h-56z",
    id: "glyph178"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\\xFA",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM225 481l80 134h76l-100 -134h-56z",
    id: "glyph179"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\\xFB",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM113 484l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph180"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\\xFC",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM335 488q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z M173 488q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph181"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\\xFD",
    horizAdvX: 445,
    d: "M46 -250l148 322l-184 368h80l141 -295l126 295h78l-304 -690h-85zM195 485l80 134h76l-100 -134h-56z",
    id: "glyph182"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\\xFE",
    horizAdvX: 560,
    d: "M70 -250v1000h70v-385q23 30 64 57.5t102 27.5q62 0 110 -32t76 -84t28 -114q0 -61 -28 -113.5t-76 -84.5t-110 -32q-41 0 -73.5 13.5t-55.5 33t-37 38.5v-325h-70zM295 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5t-20 -79 q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph183"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\\xFF",
    horizAdvX: 445,
    d: "M46 -250l148 322l-184 368h80l141 -295l126 295h78l-304 -690h-85zM305 492q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM143 492q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph184"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\\u0100",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM118 758v57h383v-57h-383z",
    id: "glyph185"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\\u0101",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM85 529v57h383v-57h-383z",
    id: "glyph186"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\\u0102",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM448 858q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph187"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\\u0103",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM415 629q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph188"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\\u0104",
    horizAdvX: 617,
    d: "M10 0l280 680h38l279 -680h-76l-73 185h-299l-73 -185h-76zM185 250h247l-123 313zM555 -141q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph189"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\\u0105",
    horizAdvX: 565,
    d: "M259 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 95.5 -23.5t70.5 -61.5v75h70v-440h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5 t-20 -79q0 -42 20 -78.5t55 -59t80 -22.5zM454 -140q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph190"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\\u0106",
    horizAdvX: 739,
    d: "M384 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5zM339 726l80 134h76l-100 -134h-56z",
    id: "glyph191"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\\u0107",
    horizAdvX: 521,
    d: "M259 -10q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18zM235 496l80 134h76l-100 -134h-56z",
    id: "glyph192"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\\u010A",
    horizAdvX: 739,
    d: "M384 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5zM371 741q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph193"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\\u010B",
    horizAdvX: 521,
    d: "M259 -10q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18zM267 511q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph194"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\\u010C",
    horizAdvX: 739,
    d: "M384 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5zM334 729l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph195"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\\u010D",
    horizAdvX: 521,
    d: "M259 -10q-40 0 -79 17t-70.5 47.5t-50.5 72.5t-19 93q0 63 30 115t81 83t114 31q49 0 92.5 -20t76.5 -57.5t47 -89.5h-76q-18 43 -56 68.5t-77 25.5q-43 0 -79.5 -19.5t-58.5 -54.5t-22 -82q0 -42 20 -78t55 -57.5t78 -21.5q42 0 77.5 22t55.5 59h79q-17 -49 -50 -83.5 t-76 -52.5t-92 -18zM230 499l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph196"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\\u010E",
    horizAdvX: 648,
    d: "M75 0v680h178q70 0 133 -24t112 -68.5t77 -107t28 -140.5q0 -73 -27 -135.5t-74.5 -108t-111 -71t-137.5 -25.5h-178zM145 70h110q79 0 142 35t100.5 96t37.5 139q0 79 -37.5 139.5t-100.5 95.5t-142 35h-110v-540zM237 729l-110 133h71l81 -109h-18l81 109h71l-110 -133 h-66z",
    id: "glyph197"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\\u010F",
    horizAdvX: 560,
    d: "M254 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 97 -22t69 -63v385h70v-750h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM265 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5t-20 -79 q0 -42 20 -78.5t55 -59t80 -22.5zM540 560l23 190h69l-43 -190h-49z",
    id: "glyph198"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\\u0110",
    horizAdvX: 648,
    d: "M75 0v295h-67v57h67v328h178q72 0 135.5 -25t111.5 -70t75.5 -107.5t27.5 -137.5q0 -73 -27 -135.5t-74.5 -108t-111 -71t-137.5 -25.5h-178zM145 70h110q79 0 142 35t100.5 96t37.5 139q0 79 -37.5 139.5t-100.5 95.5t-142 35h-110v-258h178v-57h-178v-225z",
    id: "glyph199"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\\u0111",
    horizAdvX: 560,
    d: "M254 -10q-62 0 -110.5 32.5t-76 85t-27.5 112.5q0 61 27.5 113t76 84.5t110.5 32.5q54 0 97 -22t69 -63v385h70v-750h-70v75q-19 -25 -44 -44.5t-55.5 -30t-66.5 -10.5zM265 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5t-80 -22.5t-55 -58.5t-20 -79 q0 -42 20 -78.5t55 -59t80 -22.5z",
    id: "glyph200"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\\u0112",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM86 758v57h383v-57h-383z",
    id: "glyph201"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\\u0113",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM80 532v57h383v-57h-383z",
    id: "glyph202"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\\u0116",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM279 741q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph203"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\\u0117",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM273 515q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph204"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\\u0118",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM410 -140q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph205"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\\u0119",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM406 -91q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph206"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\\u011A",
    horizAdvX: 554,
    d: "M75 0v680h404v-65h-334v-242h324v-66h-324v-242h334v-65h-404zM242 729l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph207"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\\u011B",
    horizAdvX: 540,
    d: "M281 -7q-66 0 -120.5 28.5t-87.5 80t-33 120.5q0 64 31 116t83 83t116 31q62 0 114 -31t84 -82t32 -113v-28h-416v65h342q-12 50 -55.5 84.5t-100.5 34.5q-47 0 -82.5 -22t-55.5 -59.5t-20 -84.5q0 -46 23 -80.5t59 -53.5t76 -19q31 0 57.5 7t49 21t40.5 36l53 -44 q-22 -28 -53.5 -48.5t-66.5 -31t-69 -10.5zM236 503l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph208"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\\u011E",
    horizAdvX: 791,
    d: "M395 -8q-72 0 -135 27t-111.5 75t-76 112t-27.5 137q0 69 26.5 132t73 112t109 77.5t134.5 28.5q83 0 152 -31.5t119 -88t72 -131.5h-74q-32 83 -102.5 132t-159.5 49q-58 0 -109 -21.5t-89.5 -60t-60 -89t-21.5 -109.5q0 -58 21.5 -108.5t59.5 -89.5t89 -61t110 -22 q62 0 117 24t95.5 68t60.5 103h-276v61h354l-7 -42q-11 -64 -43 -116t-79.5 -89.5t-104 -58t-117.5 -20.5zM526 867q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph209"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\\u011F",
    horizAdvX: 565,
    d: "M270 -250q-42 0 -77.5 15t-63 41t-44.5 59t-23 70h70q12 -52 52 -83.5t86 -31.5q44 0 79 21.5t55.5 57.5t20.5 79v96q-14 -20 -37.5 -39.5t-55 -32t-72.5 -12.5q-62 0 -111 32t-76.5 84.5t-27.5 113.5t27.5 113.5t76.5 84.5t111 32q41 0 73.5 -13.5t55.5 -33t36 -37.5v74 h70v-462q0 -63 -30 -114.5t-81 -82.5t-114 -31zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5q-43 0 -78.5 -22t-56 -58t-20.5 -80q0 -43 20.5 -79.5t56 -58.5t78.5 -22zM410 631q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64 h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph210"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\\u0120",
    horizAdvX: 791,
    d: "M395 -8q-72 0 -135 27t-111.5 75t-76 112t-27.5 137q0 69 26.5 132t73 112t109 77.5t134.5 28.5q83 0 152 -31.5t119 -88t72 -131.5h-74q-32 83 -102.5 132t-159.5 49q-58 0 -109 -21.5t-89.5 -60t-60 -89t-21.5 -109.5q0 -58 21.5 -108.5t59.5 -89.5t89 -61t110 -22 q62 0 117 24t95.5 68t60.5 103h-276v61h354l-7 -42q-11 -64 -43 -116t-79.5 -89.5t-104 -58t-117.5 -20.5zM389 750q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph211"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\\u0121",
    horizAdvX: 565,
    d: "M270 -250q-42 0 -77.5 15t-63 41t-44.5 59t-23 70h70q12 -52 52 -83.5t86 -31.5q44 0 79 21.5t55.5 57.5t20.5 79v96q-14 -20 -37.5 -39.5t-55 -32t-72.5 -12.5q-62 0 -111 32t-76.5 84.5t-27.5 113.5t27.5 113.5t76.5 84.5t111 32q41 0 73.5 -13.5t55.5 -33t36 -37.5v74 h70v-462q0 -63 -30 -114.5t-81 -82.5t-114 -31zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5q-43 0 -78.5 -22t-56 -58t-20.5 -80q0 -43 20.5 -79.5t56 -58.5t78.5 -22zM273 514q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31 q0 -19 -13 -32t-31 -13z",
    id: "glyph212"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\\u0122",
    horizAdvX: 791,
    d: "M395 -8q-72 0 -135 27t-111.5 75t-76 112t-27.5 137q0 69 26.5 132t73 112t109 77.5t134.5 28.5q83 0 152 -31.5t119 -88t72 -131.5h-74q-32 83 -102.5 132t-159.5 49q-58 0 -109 -21.5t-89.5 -60t-60 -89t-21.5 -109.5q0 -58 21.5 -108.5t59.5 -89.5t89 -61t110 -22 q62 0 117 24t95.5 68t60.5 103h-276v61h354l-7 -42q-11 -64 -43 -116t-79.5 -89.5t-104 -58t-117.5 -20.5zM281 -189l80 134h76l-100 -134h-56z",
    id: "glyph213"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\\u0123",
    horizAdvX: 565,
    d: "M270 -250q-42 0 -77.5 15t-63 41t-44.5 59t-23 70h70q12 -52 52 -83.5t86 -31.5q44 0 79 21.5t55.5 57.5t20.5 79v96q-14 -20 -37.5 -39.5t-55 -32t-72.5 -12.5q-62 0 -111 32t-76.5 84.5t-27.5 113.5t27.5 113.5t76.5 84.5t111 32q41 0 73.5 -13.5t55.5 -33t36 -37.5v74 h70v-462q0 -63 -30 -114.5t-81 -82.5t-114 -31zM270 60q45 0 80 22.5t55 59t20 78.5q0 43 -20 79t-55 58.5t-80 22.5q-43 0 -78.5 -22t-56 -58t-20.5 -80q0 -43 20.5 -79.5t56 -58.5t78.5 -22zM301 722l29 -38q-15 -11 -34 -31.5t-24 -41.5h2q23 0 40.5 -15.5t17.5 -40.5 q0 -16 -8 -29t-21 -20.5t-29 -7.5q-31 0 -47 21.5t-16 58.5q0 28 12.5 54.5t33.5 49.5t44 40z",
    id: "glyph214"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\\u0126",
    horizAdvX: 599,
    d: "M75 0v680h70v-306h309v306h70v-680h-70v304h-309v-304h-70zM-21 495v58h644v-58h-644z",
    id: "glyph215"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\\u0127",
    d: "M70 0v750h70v-386q21 36 55.5 60.5t83.5 24.5q55 0 91.5 -21.5t55 -60.5t18.5 -92v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -23t-48 -66.5t-15 -105.5v-184h-70zM-53 569v58h335v-58h-335z",
    id: "glyph216"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\\u012A",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM-47 758v57h383v-57h-383z",
    id: "glyph217"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\\u012B",
    horizAdvX: 343,
    d: "M137 0v440h70v-440h-70zM-20 521v57h383v-57h-383z",
    id: "glyph218"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\\u012E",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM208 -140q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph219"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\\u012F",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM115 516q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13zM104 -137q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55 q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph220"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\\u0130",
    horizAdvX: 300,
    d: "M40 0v65h75v550h-75v65h220v-65h-75v-550h75v-65h-220zM146 741q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph221"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\\u0131",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70z",
    id: "glyph222"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\\u0136",
    horizAdvX: 474,
    d: "M75 0v680h70v-319l229 319h90l-250 -340l250 -340h-90l-229 319v-319h-70zM133 -175l80 134h76l-100 -134h-56z",
    id: "glyph223"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\\u0137",
    horizAdvX: 416,
    d: "M70 0v750h70v-507l161 198h93l-181 -214l193 -227h-93l-173 211v-211h-70zM96 -175l80 134h76l-100 -134h-56z",
    id: "glyph224"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\\u0139",
    horizAdvX: 468,
    d: "M75 0v680h70v-610h283v-70h-353zM76 726l80 134h76l-100 -134h-56z",
    id: "glyph225"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\\u013A",
    horizAdvX: 220,
    d: "M75 0v750h70v-750h-70zM79 796l80 134h76l-100 -134h-56z",
    id: "glyph226"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\\u013B",
    horizAdvX: 468,
    d: "M75 0v680h70v-610h283v-70h-353zM119 -180l80 134h76l-100 -134h-56z",
    id: "glyph227"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\\u013C",
    horizAdvX: 220,
    d: "M75 0v750h70v-750h-70zM-5 -180l80 134h76l-100 -134h-56z",
    id: "glyph228"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\\u013D",
    horizAdvX: 468,
    d: "M75 0v680h70v-610h283v-70h-353zM199 490l23 190h69l-43 -190h-49z",
    id: "glyph229"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\\u013E",
    horizAdvX: 298,
    d: "M75 0v750h70v-750h-70zM206 560l23 190h69l-43 -190h-49z",
    id: "glyph230"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\\u0141",
    horizAdvX: 468,
    d: "M75 0v680h70v-610h283v-70h-353zM-31 192v58h288v-58h-288z",
    id: "glyph231"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\\u0142",
    horizAdvX: 220,
    d: "M75 0v750h70v-750h-70zM-4 260v65h231v-65h-231z",
    id: "glyph232"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\\u0143",
    horizAdvX: 602,
    d: "M75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70zM251 719l80 134h76l-100 -134h-56z",
    id: "glyph233"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\\u0144",
    d: "M70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5t-15 -98.5v-184h-70zM236 494l80 134h76l-100 -134h-56z",
    id: "glyph234"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\\u0145",
    horizAdvX: 602,
    d: "M75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70zM204 -180l80 134h76l-100 -134h-56z",
    id: "glyph235"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\\u0146",
    d: "M70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5t-15 -98.5v-184h-70zM150 -175l80 134h76l-100 -134h-56z",
    id: "glyph236"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\\u0147",
    horizAdvX: 602,
    d: "M75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70zM246 722l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph237"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\\u0148",
    d: "M70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5t-15 -98.5v-184h-70zM231 497l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph238"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\\u014A",
    horizAdvX: 602,
    d: "M387 -175h-12v68q38 0 60 25t22 65v152h70v-151q0 -42 -18 -78.5t-49.5 -58.5t-72.5 -22zM75 0v680h30l352 -500v500h70v-679h-30l-352 500v-501h-70z",
    id: "glyph239"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\\u014B",
    d: "M266 -170q15 -5 26 -5q38 0 60 25t22 65v278h70v-277q0 -42 -18 -78.5t-49.5 -58.5t-72.5 -22q-15 0 -30 2.5t-30 7.5zM70 0v440h70v-76q21 36 57 60.5t85 24.5q52 0 88 -20.5t55 -59t19 -94.5v-275h-70v275q0 26 -7.5 50t-26 39t-50.5 15q-54 0 -87 -26t-48 -70.5 t-15 -98.5v-184h-70z",
    id: "glyph240"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\\u014C",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM204 770v57h383v-57h-383z",
    id: "glyph241"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\\u014D",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM78 531v57h383v-57h-383z",
    id: "glyph242"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\\u0150",
    horizAdvX: 789,
    d: "M394 -8q-72 0 -135 27.5t-111 76t-75.5 111.5t-27.5 135t27 135t75.5 111.5t111.5 75.5t135 27q73 0 136.5 -27t111.5 -75t75 -111t27 -136q0 -75 -28 -138.5t-77 -111t-112 -74t-133 -26.5zM394 62q59 0 109.5 21.5t89 60t60 89.5t21.5 109t-21.5 108.5t-60 89t-89.5 60 t-109 21.5t-108.5 -21.5t-89 -60t-60 -89t-21.5 -108.5t21.5 -109t60 -89.5t89 -60t108.5 -21.5zM296 734l60 143h71l-80 -143h-51zM407 734l60 143h71l-80 -143h-51z",
    id: "glyph243"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\\u0151",
    horizAdvX: 540,
    d: "M270 -7q-63 0 -115.5 30.5t-83.5 82.5t-31 116t31 116t83 83t116 31t116 -31t83 -83t31 -116t-31 -116t-83.5 -82.5t-115.5 -30.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80 t58 -57.5t80.5 -21.5zM170 495l60 143h71l-80 -143h-51zM281 495l60 143h71l-80 -143h-51z",
    id: "glyph244"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\\u0152",
    horizAdvX: 998,
    d: "M425 0q-72 0 -135.5 25t-111.5 70t-75.5 107.5t-27.5 137.5q0 74 27 136t74.5 107.5t111.5 71t137 25.5h512v-65h-334v-242h324v-66h-324v-242h334v-65h-512zM423 70h110v540h-110q-78 0 -141.5 -35t-101 -95.5t-37.5 -139.5q0 -78 37.5 -139t101 -96t141.5 -35z",
    id: "glyph245"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\\u0153",
    horizAdvX: 929,
    d: "M276 -7q-64 0 -117.5 29t-86 80.5t-32.5 119.5q0 64 31 116t83 83t116 31q60 0 111.5 -28.5t83.5 -78.5q35 55 87 81t101 26q62 0 116 -28t87 -78t33 -116v-37h-387q7 -39 30.5 -68t57 -45.5t70.5 -16.5q38 0 73 17.5t57 48.5h80q-29 -66 -86.5 -101t-119.5 -35 t-114 27.5t-85 79.5q-32 -50 -83.5 -78.5t-105.5 -28.5zM270 63q44 0 80.5 21.5t58 57.5t21.5 80q0 45 -21.5 81t-57.5 57.5t-81 21.5q-44 0 -80.5 -21.5t-58 -57.5t-21.5 -81q0 -44 21.5 -80t58 -57.5t80.5 -21.5zM504 258h312q-7 27 -21.5 50t-35 39.5t-45.5 25.5t-54 9 q-28 0 -53.5 -9t-46.5 -25.5t-35.5 -39t-20.5 -50.5z",
    id: "glyph246"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\\u0154",
    horizAdvX: 544,
    d: "M75 0v680h218q61 0 110 -26.5t77.5 -73t28.5 -105.5q0 -58 -27 -103t-71.5 -71.5t-99.5 -30.5l209 -270h-94l-199 269h-82v-269h-70zM145 336h158q42 0 72.5 19.5t47 51.5t16.5 70q0 39 -16.5 69.5t-46.5 48.5t-73 18h-158v-277zM215 726l80 134h76l-100 -134h-56z",
    id: "glyph247"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\\u0155",
    horizAdvX: 326,
    d: "M70 0v440h70v-86q13 37 29.5 57.5t37.5 29t45 8.5q11 0 22.5 -2t21.5 -7v-91q-12 11 -25 16.5t-27 5.5q-32 0 -55.5 -22.5t-36 -57t-12.5 -71.5v-220h-70zM161 493l80 134h76l-100 -134h-56z",
    id: "glyph248"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\\u0156",
    horizAdvX: 544,
    d: "M75 0v680h218q61 0 110 -26.5t77.5 -73t28.5 -105.5q0 -58 -27 -103t-71.5 -71.5t-99.5 -30.5l209 -270h-94l-199 269h-82v-269h-70zM145 336h158q42 0 72.5 19.5t47 51.5t16.5 70q0 39 -16.5 69.5t-46.5 48.5t-73 18h-158v-277zM146 -170l80 134h76l-100 -134h-56z",
    id: "glyph249"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\\u0157",
    horizAdvX: 326,
    d: "M70 0v440h70v-86q13 37 29.5 57.5t37.5 29t45 8.5q11 0 22.5 -2t21.5 -7v-91q-12 11 -25 16.5t-27 5.5q-32 0 -55.5 -22.5t-36 -57t-12.5 -71.5v-220h-70zM3 -180l80 134h76l-100 -134h-56z",
    id: "glyph250"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\\u0158",
    horizAdvX: 544,
    d: "M75 0v680h218q61 0 110 -26.5t77.5 -73t28.5 -105.5q0 -58 -27 -103t-71.5 -71.5t-99.5 -30.5l209 -270h-94l-199 269h-82v-269h-70zM145 336h158q42 0 72.5 19.5t47 51.5t16.5 70q0 39 -16.5 69.5t-46.5 48.5t-73 18h-158v-277zM210 729l-110 133h71l81 -109h-18l81 109 h71l-110 -133h-66z",
    id: "glyph251"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\\u0159",
    horizAdvX: 326,
    d: "M70 0v440h70v-86q13 37 29.5 57.5t37.5 29t45 8.5q11 0 22.5 -2t21.5 -7v-91q-12 11 -25 16.5t-27 5.5q-32 0 -55.5 -22.5t-36 -57t-12.5 -71.5v-220h-70zM156 496l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph252"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\\u015A",
    horizAdvX: 574,
    d: "M299 -13q-57 0 -101.5 10.5t-77 32t-53.5 54t-30 75.5h83q7 -36 28.5 -60t59 -36t91.5 -12q48 0 88 12.5t64.5 41.5t24.5 77q0 33 -21.5 56.5t-55 39t-69.5 26t-66 17.5q-52 12 -91 29t-65 39.5t-39 49.5t-13 60q0 48 17.5 84t48.5 60t72 35.5t87 11.5q50 0 89 -9 t68.5 -27.5t49 -46.5t28.5 -65h-76q-10 44 -49.5 66t-109.5 22q-42 0 -77 -12t-55.5 -37t-20.5 -64q0 -35 20 -59t51 -39t66.5 -25t66.5 -18q44 -11 83 -25.5t69 -35.5t47 -52t17 -76q0 -53 -20.5 -91t-56 -62t-80 -35.5t-92.5 -11.5zM251 736l80 134h76l-100 -134h-56z",
    id: "glyph253"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\\u015B",
    horizAdvX: 402,
    d: "M203 -13q-51 0 -87.5 15t-58.5 45.5t-30 75.5h74q8 -29 23 -46.5t36 -24.5t47 -7q48 0 72 18t24 54q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19 t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5zM165 491l80 134h76l-100 -134h-56z",
    id: "glyph254"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\\u015E",
    horizAdvX: 574,
    d: "M299 -13q-57 0 -101.5 10.5t-77 32t-53.5 54t-30 75.5h83q7 -36 28.5 -60t59 -36t91.5 -12q48 0 88 12.5t64.5 41.5t24.5 77q0 33 -21.5 56.5t-55 39t-69.5 26t-66 17.5q-52 12 -91 29t-65 39.5t-39 49.5t-13 60q0 48 17.5 84t48.5 60t72 35.5t87 11.5q50 0 89 -9 t68.5 -27.5t49 -46.5t28.5 -65h-76q-10 44 -49.5 66t-109.5 22q-42 0 -77 -12t-55.5 -37t-20.5 -64q0 -35 20 -59t51 -39t66.5 -25t66.5 -18q44 -11 83 -25.5t69 -35.5t47 -52t17 -76q0 -53 -20.5 -91t-56 -62t-80 -35.5t-92.5 -11.5zM170 -245l25 52q22 -7 43.5 -11.5 t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph255"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\\u015F",
    horizAdvX: 402,
    d: "M203 -13q-51 0 -87.5 15t-58.5 45.5t-30 75.5h74q8 -29 23 -46.5t36 -24.5t47 -7q48 0 72 18t24 54q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19 t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5zM74 -239l25 52q22 -7 43.5 -11.5t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5 t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph256"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\\u0160",
    horizAdvX: 574,
    d: "M299 -13q-57 0 -101.5 10.5t-77 32t-53.5 54t-30 75.5h83q7 -36 28.5 -60t59 -36t91.5 -12q48 0 88 12.5t64.5 41.5t24.5 77q0 33 -21.5 56.5t-55 39t-69.5 26t-66 17.5q-52 12 -91 29t-65 39.5t-39 49.5t-13 60q0 48 17.5 84t48.5 60t72 35.5t87 11.5q50 0 89 -9 t68.5 -27.5t49 -46.5t28.5 -65h-76q-10 44 -49.5 66t-109.5 22q-42 0 -77 -12t-55.5 -37t-20.5 -64q0 -35 20 -59t51 -39t66.5 -25t66.5 -18q44 -11 83 -25.5t69 -35.5t47 -52t17 -76q0 -53 -20.5 -91t-56 -62t-80 -35.5t-92.5 -11.5zM246 739l-110 133h71l81 -109h-18 l81 109h71l-110 -133h-66z",
    id: "glyph257"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\\u0161",
    horizAdvX: 402,
    d: "M203 -13q-51 0 -87.5 15t-58.5 45.5t-30 75.5h74q8 -29 23 -46.5t36 -24.5t47 -7q48 0 72 18t24 54q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19 t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5zM160 494l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph258"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\\u0164",
    horizAdvX: 520,
    d: "M225 2v614h-205v66h480v-66h-205v-614h-70zM225 729l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph259"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\\u0165",
    horizAdvX: 339,
    d: "M135 0v375h-110v65h110v171h70v-171h109v-65h-109v-375h-70zM245 493l23 190h69l-43 -190h-49z",
    id: "glyph260"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\\u016A",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM121 744v57h383v-57h-383z",
    id: "glyph261"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\\u016B",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM64 513v57h383v-57h-383z",
    id: "glyph262"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\\u016C",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM451 844q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73 q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph263"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\\u016D",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM394 613q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73 q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph264"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\\u016E",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM318 696q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58 q0 -46 -33 -77.5t-80 -31.5zM319 754q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph265"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\\u016F",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM261 465q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58 q0 -46 -33 -77.5t-80 -31.5zM262 523q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph266"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\\u0170",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM213 708l60 143h71l-80 -143h-51zM324 708l60 143h71l-80 -143h-51z",
    id: "glyph267"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\\u0171",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM156 477l60 143h71l-80 -143h-51zM267 477l60 143h71l-80 -143h-51z",
    id: "glyph268"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\\u0172",
    horizAdvX: 627,
    d: "M314 -9q-76 0 -133 27.5t-89 80t-32 126.5v455h70v-465q0 -52 24 -86.5t66 -51t94 -16.5q55 0 96 17.5t64 52t23 84.5v465h70v-455q0 -74 -32 -126.5t-88.5 -80t-132.5 -27.5zM350 -139q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33 t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph269"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\\u0173",
    d: "M227 -9q-52 0 -87 23.5t-52.5 62.5t-17.5 88v275h70v-275q0 -26 7.5 -50t26 -39t50.5 -15q59 0 91.5 26t45.5 70.5t13 98.5v184h70v-440h-70v75q-25 -42 -61.5 -63t-85.5 -21zM399 -138q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33 t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph270"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\\u0174",
    horizAdvX: 813,
    d: "M172 0l-147 680h72l112 -525l-18 2l200 520h32l199 -520l-18 -2l113 525h71l-146 -680h-34l-212 566h22l-212 -566h-34zM266 731l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph271"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\\u0175",
    horizAdvX: 724,
    d: "M197 1l-187 439h78l132 -339l124 317h36l124 -317l132 339h78l-185 -439h-47l-120 298l-118 -298h-47zM218 487l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph272"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\\u0176",
    horizAdvX: 605,
    d: "M268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70zM161 721l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph273"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\\u0177",
    horizAdvX: 445,
    d: "M46 -250l148 322l-184 368h80l141 -295l126 295h78l-304 -690h-85zM83 488l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph274"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\\u0178",
    horizAdvX: 605,
    d: "M268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70zM383 725q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM221 725q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph275"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\\u0179",
    horizAdvX: 580,
    d: "M25 0l403 615h-382v65h509l-403 -615h386v-65h-513zM246 727l80 134h76l-100 -134h-56z",
    id: "glyph276"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\\u017A",
    horizAdvX: 455,
    d: "M15 0l268 375h-251v65h385l-268 -375h281v-65h-415zM184 486l80 134h76l-100 -134h-56z",
    id: "glyph277"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\\u017B",
    horizAdvX: 580,
    d: "M25 0l403 615h-382v65h509l-403 -615h386v-65h-513zM278 742q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph278"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\\u017C",
    horizAdvX: 455,
    d: "M15 0l268 375h-251v65h385l-268 -375h281v-65h-415zM216 501q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph279"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\\u017D",
    horizAdvX: 580,
    d: "M25 0l403 615h-382v65h509l-403 -615h386v-65h-513zM241 730l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph280"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\\u017E",
    horizAdvX: 455,
    d: "M15 0l268 375h-251v65h385l-268 -375h281v-65h-415zM179 489l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph281"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\\u0218",
    horizAdvX: 574,
    d: "M299 -13q-57 0 -101.5 10.5t-77 32t-53.5 54t-30 75.5h83q7 -36 28.5 -60t59 -36t91.5 -12q48 0 88 12.5t64.5 41.5t24.5 77q0 33 -21.5 56.5t-55 39t-69.5 26t-66 17.5q-52 12 -91 29t-65 39.5t-39 49.5t-13 60q0 48 17.5 84t48.5 60t72 35.5t87 11.5q50 0 89 -9 t68.5 -27.5t49 -46.5t28.5 -65h-76q-10 44 -49.5 66t-109.5 22q-42 0 -77 -12t-55.5 -37t-20.5 -64q0 -35 20 -59t51 -39t66.5 -25t66.5 -18q44 -11 83 -25.5t69 -35.5t47 -52t17 -76q0 -53 -20.5 -91t-56 -62t-80 -35.5t-92.5 -11.5zM184 -193l80 134h76l-100 -134h-56z ",
    id: "glyph282"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\\u0219",
    horizAdvX: 402,
    d: "M203 -13q-51 0 -87.5 15t-58.5 45.5t-30 75.5h74q8 -29 23 -46.5t36 -24.5t47 -7q48 0 72 18t24 54q0 21 -17 37t-52 27q-15 5 -37.5 11t-45.5 13t-42 15q-31 15 -49.5 39t-18.5 58q0 45 22 74.5t57.5 44t76.5 14.5q62 0 105 -25.5t58 -93.5h-75q-7 23 -19 36.5t-29.5 19 t-41.5 5.5q-30 0 -55 -13t-25 -45t22 -45.5t46 -21.5q12 -3 34.5 -8.5t47.5 -13t44 -16.5q34 -16 51 -42t17 -61q0 -49 -23.5 -79.5t-63 -45t-87.5 -14.5zM88 -187l80 134h76l-100 -134h-56z",
    id: "glyph283"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\\u021A",
    horizAdvX: 520,
    d: "M225 2v614h-205v66h480v-66h-205v-614h-70zM145 -175l80 134h76l-100 -134h-56z",
    id: "glyph284"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\\u021B",
    horizAdvX: 339,
    d: "M135 0v375h-110v65h110v171h70v-171h109v-65h-109v-375h-70zM55 -180l80 134h76l-100 -134h-56z",
    id: "glyph285"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\\u0237",
    horizAdvX: 235,
    d: "M15 -243q-33 0 -67.5 13t-62.5 45l46 50q12 -16 32.5 -28t39.5 -12q38 0 60 25t22 65v525h70v-524q0 -42 -18 -78.5t-49.5 -58.5t-72.5 -22z",
    id: "glyph286"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\\u02C6",
    horizAdvX: 366,
    d: "M10 750l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph287"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\\u02C7",
    horizAdvX: 346,
    d: "M140 751l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph288"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\\u02D8",
    horizAdvX: 600,
    d: "M313 880q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph289"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\\u02D9",
    horizAdvX: 229,
    d: "M115 516q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph290"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\\u02DA",
    horizAdvX: 306,
    d: "M153 680q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58q0 -46 -33 -77.5t-80 -31.5zM154 738q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph291"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\\u02DB",
    horizAdvX: 600,
    d: "M383 -140q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph292"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\\u02DC",
    horizAdvX: 471,
    d: "M301 718q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph293"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\\u02DD",
    horizAdvX: 322,
    d: "M40 750l60 143h71l-80 -143h-51zM151 750l60 143h71l-80 -143h-51z",
    id: "glyph294"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\\u0300",
    horizAdvX: 0,
    d: "M110 750l-110 143h76l90 -143h-56z",
    id: "glyph295"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\\u0301",
    horizAdvX: 0,
    d: "M20 750l80 134h76l-100 -134h-56z",
    id: "glyph296"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\\u0302",
    horizAdvX: 0,
    d: "M10 750l110 133h66l110 -133h-71l-81 99h18l-81 -99h-71z",
    id: "glyph297"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\\u0303",
    horizAdvX: 0,
    d: "M301 718q-24 0 -45.5 12t-40 28.5t-34.5 28.5t-28 12q-16 0 -25 -11.5t-12 -27.5t-2 -30h-49q-1 36 9.5 64t32 44t53.5 16q26 0 47.5 -12t40 -28t32.5 -28t23 -12q18 0 26.5 8t11.5 23.5t3 37.5h49q4 -32 -4.5 -60.5t-30 -46.5t-57.5 -18z",
    id: "glyph298"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\\u0304",
    horizAdvX: 0,
    d: "M84 750v57h383v-57h-383z",
    id: "glyph299"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\\u0306",
    horizAdvX: 0,
    d: "M313 880q0 -33 -18.5 -62.5t-50.5 -48.5t-71 -19q-36 0 -68 18t-52 48t-20 64h73q0 -27 20.5 -48.5t49.5 -21.5q19 0 34 10t24 26t9 34h70z",
    id: "glyph300"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\\u0307",
    horizAdvX: 0,
    d: "M115 516q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph301"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\\u0308",
    horizAdvX: 0,
    d: "M312 750q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM150 750q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph302"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\\u030A",
    horizAdvX: 0,
    d: "M153 680q-29 0 -55 14t-42 39t-16 56t15.5 56t41 40t56.5 15q30 0 55.5 -14t41.5 -39t16 -58q0 -46 -33 -77.5t-80 -31.5zM154 738q23 0 38 15t15 37t-15.5 36.5t-38.5 14.5t-38.5 -14.5t-15.5 -36.5t16.5 -37t38.5 -15z",
    id: "glyph303"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\\u030B",
    horizAdvX: 0,
    d: "M40 750l60 143h71l-80 -143h-51zM151 750l60 143h71l-80 -143h-51z",
    id: "glyph304"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\\u030C",
    horizAdvX: 0,
    d: "M140 751l-110 133h71l81 -109h-18l81 109h71l-110 -133h-66z",
    id: "glyph305"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\\u0312",
    horizAdvX: 0,
    d: "M149 710l29 -38q-15 -11 -34 -31.5t-24 -41.5h2q23 0 40.5 -15.5t17.5 -40.5q0 -16 -8 -29t-21 -20.5t-29 -7.5q-31 0 -47 21.5t-16 58.5q0 28 12.5 54.5t33.5 49.5t44 40z",
    id: "glyph306"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\\u0326",
    horizAdvX: 0,
    d: "M43 -181l80 134h76l-100 -134h-56z",
    id: "glyph307"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\\u0327",
    horizAdvX: 0,
    d: "M131 -231l25 52q22 -7 43.5 -11.5t41.5 -4.5q33 0 56.5 11t23.5 42q0 23 -19.5 35.5t-46.5 12.5q-17 0 -35 -3.5t-34 -5.5l66 146l56 1l-43 -90q1 1 26 1q32 0 59 -25.5t27 -72.5q0 -39 -20.5 -63t-51.5 -35t-64 -11q-26 0 -55 5.5t-55 15.5z",
    id: "glyph308"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\\u0328",
    horizAdvX: 0,
    d: "M383 -140q-18 0 -33.5 8t-25 21.5t-9.5 28.5q0 24 12.5 46.5t31.5 37.5h58q-19 -14 -32 -33t-13 -33q0 -13 9 -18t16 -5q6 0 18.5 5.5t21.5 12.5l1 -55q-10 -8 -24.5 -12t-30.5 -4z",
    id: "glyph309"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\\u039E",
    horizAdvX: 544,
    d: "M70 615v65h404v-65h-404zM70 0v65h404v-65h-404zM100 307v66h334v-66h-334z",
    id: "glyph310"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\\u1E80",
    horizAdvX: 813,
    d: "M172 0l-147 680h72l112 -525l-18 2l200 520h32l199 -520l-18 -2l113 525h71l-146 -680h-34l-212 566h22l-212 -566h-34zM374 724l-110 143h76l90 -143h-56z",
    id: "glyph311"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\\u1E81",
    horizAdvX: 724,
    d: "M197 1l-187 439h78l132 -339l124 317h36l124 -317l132 339h78l-185 -439h-47l-120 298l-118 -298h-47zM326 480l-110 143h76l90 -143h-56z",
    id: "glyph312"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\\u1E82",
    horizAdvX: 813,
    d: "M172 0l-147 680h72l112 -525l-18 2l200 520h32l199 -520l-18 -2l113 525h71l-146 -680h-34l-212 566h22l-212 -566h-34zM378 728l80 134h76l-100 -134h-56z",
    id: "glyph313"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\\u1E83",
    horizAdvX: 724,
    d: "M197 1l-187 439h78l132 -339l124 317h36l124 -317l132 339h78l-185 -439h-47l-120 298l-118 -298h-47zM330 484l80 134h76l-100 -134h-56z",
    id: "glyph314"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\\u1E84",
    horizAdvX: 813,
    d: "M172 0l-147 680h72l112 -525l-18 2l200 520h32l199 -520l-18 -2l113 525h71l-146 -680h-34l-212 566h22l-212 -566h-34zM488 735q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM326 735q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5 t32 -12.5t13 -31.5t-13 -32t-32 -13z",
    id: "glyph315"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\\u1E85",
    horizAdvX: 724,
    d: "M197 1l-187 439h78l132 -339l124 317h36l124 -317l132 339h78l-185 -439h-47l-120 298l-118 -298h-47zM440 491q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5t13 -31.5t-13 -32t-32 -13zM278 491q-19 0 -31.5 13t-12.5 32t12.5 31.5t31.5 12.5t32 -12.5 t13 -31.5t-13 -32t-32 -13z",
    id: "glyph316"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\\u1E9E",
    horizAdvX: 569,
    d: "M70 0v680h331q23 0 37.5 -14t14.5 -33q0 -10 -3.5 -23t-9.5 -26t-13 -24l-90 -154q57 -9 95 -37t57.5 -69.5t19.5 -94.5q0 -63 -26 -109t-74 -71t-114 -25h-119v67h119q44 0 76 17.5t49.5 50.5t17.5 77q0 34 -17.5 61t-49.5 45.5t-76 25.5q-16 2 -30.5 11t-14.5 28 q0 7 2.5 14t3.5 9l122 208h-238v-614h-70z",
    id: "glyph317"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\\u1EF2",
    horizAdvX: 605,
    d: "M268 0v320l-258 360h90l203 -291l203 291h89l-257 -360v-320h-70zM269 714l-110 143h76l90 -143h-56z",
    id: "glyph318"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\\u1EF3",
    horizAdvX: 445,
    d: "M46 -250l148 322l-184 368h80l141 -295l126 295h78l-304 -690h-85zM191 481l-110 143h76l90 -143h-56z",
    id: "glyph319"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\\u2013",
    horizAdvX: 390,
    d: "M23 180v58h345v-58h-345z",
    id: "glyph320"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\\u2014",
    horizAdvX: 689,
    d: "M23 180v58h644v-58h-644z",
    id: "glyph321"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\\u2018",
    horizAdvX: 181,
    d: "M82 458q-31 0 -43 23t-12 54q0 28 12.5 57.5t33 56t43.5 43.5l29 -37q-9 -9 -23 -26.5t-24.5 -36t-11.5 -32.5h7q17 -1 29 -16t12 -34q0 -16 -8 -27.5t-19.5 -18t-24.5 -6.5z",
    id: "glyph322"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\\u2019",
    horizAdvX: 181,
    d: "M56 456l-29 38q9 9 23 25.5t25 35t11 32.5h-5q-18 0 -30.5 15.5t-12.5 35.5q0 16 8 27.5t20 18t24 6.5q32 0 44 -23t12 -55q0 -28 -12.5 -57.5t-33 -55t-44.5 -43.5z",
    id: "glyph323"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\\u201A",
    horizAdvX: 232,
    d: "M70 -136l-29 42q8 9 20.5 25.5t23.5 35t14 33.5h-2q-23 0 -40.5 17t-17.5 44q0 18 8 32t21 22.5t29 8.5q31 0 47 -23.5t16 -64.5q0 -31 -12.5 -63.5t-33 -60.5t-44.5 -48z",
    id: "glyph324"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\\u201C",
    horizAdvX: 348,
    d: "M82 458q-31 0 -43 23t-12 54q0 28 12.5 57.5t33 56t43.5 43.5l29 -39q-9 -8 -23 -25t-24.5 -35.5t-11.5 -32.5l7 -1q17 -1 29 -15.5t12 -33.5q0 -16 -8 -27.5t-19.5 -18t-24.5 -6.5zM236 458q-31 0 -43.5 23t-12.5 54q0 28 12.5 58t33.5 56t44 43l27 -39 q-9 -8 -22.5 -24.5t-24 -35t-11.5 -32.5l8 -1q17 -1 28.5 -15.5t11.5 -34.5q0 -16 -8 -27.5t-19.5 -18t-23.5 -6.5z",
    id: "glyph325"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\\u201D",
    horizAdvX: 348,
    d: "M56 456l-29 38q9 9 23 25.5t25 35t11 32.5h-5q-18 0 -30.5 15.5t-12.5 35.5q0 16 8 27.5t20 18t24 6.5q32 0 44 -23t12 -55q0 -28 -12.5 -57.5t-33 -55t-44.5 -43.5zM209 456l-29 38q10 9 24 25.5t25 35t11 32.5h-7q-16 2 -29 17t-13 34q0 16 8 27.5t20 18t24 6.5 q32 0 43.5 -23t11.5 -55q0 -27 -12.5 -56.5t-32.5 -55.5t-44 -44z",
    id: "glyph326"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\\u201E",
    horizAdvX: 365,
    d: "M236 -136l-29 42q8 9 20.5 25.5t23.5 35t14 33.5h-2q-23 0 -40.5 17t-17.5 44q0 18 8 32t21 22.5t29 8.5q31 0 47 -23.5t16 -64.5q0 -31 -12.5 -63.5t-33 -60.5t-44.5 -48zM70 -136l-29 42q8 9 20.5 25.5t23.5 35t14 33.5h-2q-23 0 -40.5 17t-17.5 44q0 18 8 32t21 22.5 t29 8.5q31 0 47 -23.5t16 -64.5q0 -31 -12.5 -63.5t-33 -60.5t-44.5 -48z",
    id: "glyph327"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\\u2022",
    horizAdvX: 300,
    d: "M150 208q-31 0 -57 15.5t-41.5 41.5t-15.5 57q0 32 15.5 57.5t41.5 41t57 15.5q32 0 57.5 -15.5t41 -41t15.5 -57.5q0 -31 -15.5 -57t-41 -41.5t-57.5 -15.5z",
    id: "glyph328"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\\u2026",
    horizAdvX: 667,
    d: "M533 -10q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5zM133 -10q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5zM333 -10q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40 t-18 -40.5t-41 -16.5z",
    id: "glyph329"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\\u2039",
    horizAdvX: 392,
    d: "M323 27l-254 160v71l254 160v-76l-210 -132v26l210 -134v-75z",
    id: "glyph330"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\\u203A",
    horizAdvX: 392,
    d: "M69 27v75l210 134v-26l-210 132v76l254 -160v-71z",
    id: "glyph331"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\\u2044",
    horizAdvX: 444,
    d: "M45 0l286 679h68l-287 -679h-67z",
    id: "glyph332"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\\u20AC",
    horizAdvX: 847,
    d: "M492 -10q-71 0 -132.5 27.5t-108 76t-72.5 111.5t-26 134q0 70 25 133t71 112t108 77t135 28q71 0 133 -27t109 -75.5t72 -113.5h-77q-40 74 -105 109t-142 35q-42 0 -87 -18.5t-84.5 -54.5t-63.5 -87.5t-24 -117.5q0 -57 21 -107.5t58 -88.5t85.5 -59.5t104.5 -21.5 q78 0 141 41t97 105h77q-25 -65 -72.5 -114t-110 -76.5t-132.5 -27.5zM35 377l20 57h415l-20 -57h-415zM35 246l20 57h415l-20 -57h-415z",
    id: "glyph333"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BF",
    unicode: "\\u20BF",
    horizAdvX: 609,
    d: "M75 0v680h224q65 0 112 -19.5t72.5 -55t25.5 -84.5q0 -30 -7.5 -58.5t-25 -51.5t-47.5 -36q43 -11 71.5 -38t43.5 -64.5t15 -82.5q0 -57 -30 -99.5t-83 -66.5t-123 -24h-248zM162 -117v165h72v-165h-72zM288 -117v165h72v-165h-72zM145 67h198q65 0 105.5 37.5t40.5 98.5 q0 37 -18.5 65.5t-49 45.5t-67.5 17h-209v-264zM145 401h174q51 0 85.5 25.5t34.5 83.5q0 52 -35 77.5t-105 25.5h-154v-212zM162 632v165h72v-165h-72zM288 632v165h72v-165h-72z",
    id: "glyph334"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\\u2122",
    horizAdvX: 779,
    d: "M297 338l67 342h76l86 -279l86 279h76l67 -342h-64l-51 287l-84 -287h-60l-85 287l-50 -287h-64zM128 338v294h-104v48h265v-48h-105v-294h-56z",
    id: "glyph335"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\\u2212",
    horizAdvX: 460,
    d: "M68 183v70h325v-70h-325z",
    id: "glyph336"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\\u2260",
    horizAdvX: 460,
    d: "M67 277v69h325v-69h-325zM67 96v69h325v-69h-325zM46 -61l319 595h69l-320 -595h-68z",
    id: "glyph337"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\\u2264",
    horizAdvX: 460,
    d: "M393 135l-324 160v71l324 160v-74l-280 -134v26l280 -134v-75zM69 23v70h325v-70h-325z",
    id: "glyph338"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\\u2265",
    horizAdvX: 460,
    d: "M69 134v74l280 134v-26l-280 134v75l324 -160v-71zM69 23v70h325v-70h-325z",
    id: "glyph339"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniA729",
    unicode: "\\uA729",
    horizAdvX: 737,
    d: "M150 1v610h70v-610h-70zM30 376v64h626l-157 -211q54 -3 96.5 -26.5t67 -64.5t24.5 -99q0 -63 -29.5 -107.5t-77.5 -68.5t-104 -24q-19 0 -37.5 2.5t-36 8.5t-33.5 14l41 57q15 -8 31.5 -12.5t31.5 -4.5q63 0 103 37t40 99q0 60 -38.5 92t-103.5 32h-107l157 212h-494z ",
    id: "glyph340"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF8FF",
    unicode: "\\uF8FF",
    horizAdvX: 926,
    id: "glyph341"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 229,
    d: "M80 0v440h70v-440h-70zM116 504q-19 0 -32 13t-13 32q0 18 13 31t32 13q18 0 31 -13t13 -31q0 -19 -13 -32t-31 -13z",
    id: "glyph342"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown.case",
    horizAdvX: 257,
    d: "M154 477l19 -477h-88l19 477h50zM128 690q24 0 41.5 -16.5t17.5 -39.5t-17.5 -40t-41.5 -17q-23 0 -40.5 16.5t-17.5 39.5q0 24 17.5 40.5t40.5 16.5z",
    id: "glyph343"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown.case",
    horizAdvX: 497,
    d: "M286 477v-105q0 -37 -15 -67t-53 -58q-22 -16 -38.5 -27t-25.5 -19q-10 -8 -18 -21t-8 -25q0 -35 19 -56.5t47.5 -31t55.5 -9.5q29 0 56.5 10t47 31t22.5 53h71q-7 -78 -62 -120t-134 -42q-52 0 -96 19t-70.5 56t-26.5 90q0 38 24.5 67t46.5 45q11 8 25.5 18t22.5 17 q21 17 30 34.5t9 36.5v104h70zM249 690q24 0 41.5 -16.5t17.5 -39.5t-17.5 -40t-41.5 -17q-23 0 -40.5 16.5t-17.5 39.5q0 24 17.5 40.5t40.5 16.5z",
    id: "glyph344"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 267,
    d: "M133 189q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph345"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 267,
    d: "M133 279q-22 0 -40 17t-18 39q0 24 17 40.5t41 16.5q25 0 42 -16t17 -40t-18 -40.5t-41 -16.5z",
    id: "glyph346"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    horizAdvX: 0,
    d: "M76 560l23 190h69l-43 -190h-49z",
    id: "glyph347"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC6",
    k: 15,
    id: "hkern347"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC5",
    k: 15,
    id: "hkern348"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC4",
    k: 15,
    id: "hkern349"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC3",
    k: 15,
    id: "hkern350"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC2",
    k: 15,
    id: "hkern351"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC1",
    k: 15,
    id: "hkern352"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "\\xC0",
    k: 15,
    id: "hkern353"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "A",
    k: 15,
    id: "hkern354"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "t",
    k: 40,
    id: "hkern355"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: 2,
    k: 25,
    id: "hkern356"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "t",
    k: 50,
    id: "hkern357"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "T",
    k: 60,
    id: "hkern358"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "t",
    k: 40,
    id: "hkern359"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 0,
    u2: ".",
    k: 20,
    id: "hkern360"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 0,
    u2: ",",
    k: 20,
    id: "hkern361"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 4,
    u2: 3,
    k: 20,
    id: "hkern362"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 4,
    u2: 2,
    k: 30,
    id: "hkern363"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 4,
    u2: 9,
    k: 15,
    id: "hkern364"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 4,
    u2: 5,
    k: 30,
    id: "hkern365"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 5,
    u2: 2,
    k: 15,
    id: "hkern366"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: 5,
    k: 40,
    id: "hkern367"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: 0,
    k: 20,
    id: "hkern368"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: 8,
    k: 30,
    id: "hkern369"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: 6,
    k: 100,
    id: "hkern370"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: 2,
    k: 30,
    id: "hkern371"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: ".",
    k: 50,
    id: "hkern372"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 7,
    u2: ",",
    k: 50,
    id: "hkern373"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 9,
    u2: 7,
    k: 15,
    id: "hkern374"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 9,
    u2: 5,
    k: 25,
    id: "hkern375"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 9,
    u2: 6,
    k: 50,
    id: "hkern376"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 9,
    u2: ".",
    k: 50,
    id: "hkern377"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: 9,
    u2: ",",
    k: 50,
    id: "hkern378"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Y",
    k: 100,
    id: "hkern379"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "W",
    k: 50,
    id: "hkern380"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 100,
    id: "hkern381"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "S",
    k: 30,
    id: "hkern382"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\\xAE",
    k: 30,
    id: "hkern383"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "w",
    k: 47,
    id: "hkern384"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "T",
    k: 92,
    id: "hkern385"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 50,
    id: "hkern386"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "G",
    k: 48,
    id: "hkern387"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 50,
    id: "hkern388"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\\u0153",
    k: 10,
    id: "hkern389"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "q",
    k: 10,
    id: "hkern390"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "o",
    k: 10,
    id: "hkern391"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "g",
    k: 10,
    id: "hkern392"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "e",
    k: 10,
    id: "hkern393"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "d",
    k: 10,
    id: "hkern394"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "c",
    k: 10,
    id: "hkern395"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "a",
    k: 10,
    id: "hkern396"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "I",
    k: -10,
    id: "hkern397"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\\xDD",
    k: 49,
    id: "hkern398"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "Y",
    k: 49,
    id: "hkern399"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "W",
    k: 49,
    id: "hkern400"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 49,
    id: "hkern401"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "s",
    k: 15,
    id: "hkern402"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "Z",
    k: 30,
    id: "hkern403"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 63,
    id: "hkern404"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "T",
    k: 25,
    id: "hkern405"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "J",
    k: 20,
    id: "hkern406"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "I",
    k: 20,
    id: "hkern407"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "?",
    k: 15,
    id: "hkern408"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "Y",
    k: 93,
    id: "hkern409"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "X",
    k: 75,
    id: "hkern410"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "s",
    k: 15,
    id: "hkern411"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Z",
    k: 30,
    id: "hkern412"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "T",
    k: 25,
    id: "hkern413"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "J",
    k: 20,
    id: "hkern414"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "I",
    k: 20,
    id: "hkern415"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "?",
    k: 15,
    id: "hkern416"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\\xDD",
    k: 52,
    id: "hkern417"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "Y",
    k: 82,
    id: "hkern418"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 64,
    id: "hkern419"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "W",
    k: 52,
    id: "hkern420"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 52,
    id: "hkern421"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\u0153",
    k: 20,
    id: "hkern422"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\u0152",
    k: 20,
    id: "hkern423"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xFD",
    k: 35,
    id: "hkern424"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xD6",
    k: 20,
    id: "hkern425"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xD5",
    k: 20,
    id: "hkern426"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xD4",
    k: 20,
    id: "hkern427"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xD3",
    k: 20,
    id: "hkern428"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xD2",
    k: 20,
    id: "hkern429"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\\xC7",
    k: 20,
    id: "hkern430"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "y",
    k: 35,
    id: "hkern431"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "w",
    k: 35,
    id: "hkern432"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "v",
    k: 35,
    id: "hkern433"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "t",
    k: 10,
    id: "hkern434"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "q",
    k: 20,
    id: "hkern435"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "o",
    k: 20,
    id: "hkern436"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "g",
    k: 20,
    id: "hkern437"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "e",
    k: 20,
    id: "hkern438"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "d",
    k: 20,
    id: "hkern439"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "c",
    k: 20,
    id: "hkern440"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "a",
    k: 20,
    id: "hkern441"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "Q",
    k: 20,
    id: "hkern442"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "O",
    k: 20,
    id: "hkern443"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "G",
    k: 20,
    id: "hkern444"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "C",
    k: 20,
    id: "hkern445"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\u0153",
    k: 15,
    id: "hkern446"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 10,
    id: "hkern447"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 15,
    id: "hkern448"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 15,
    id: "hkern449"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 15,
    id: "hkern450"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 15,
    id: "hkern451"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 15,
    id: "hkern452"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 15,
    id: "hkern453"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 15,
    id: "hkern454"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC6",
    k: 60,
    id: "hkern455"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC5",
    k: 60,
    id: "hkern456"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC4",
    k: 60,
    id: "hkern457"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC3",
    k: 60,
    id: "hkern458"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC2",
    k: 60,
    id: "hkern459"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC1",
    k: 60,
    id: "hkern460"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\\xC0",
    k: 60,
    id: "hkern461"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 60,
    id: "hkern462"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 50,
    id: "hkern463"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 50,
    id: "hkern464"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xDD",
    k: 50,
    id: "hkern465"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "s",
    k: 15,
    id: "hkern466"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "Y",
    k: 80,
    id: "hkern467"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 84,
    id: "hkern468"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "W",
    k: 50,
    id: "hkern469"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 50,
    id: "hkern470"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "T",
    k: 25,
    id: "hkern471"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "J",
    k: 20,
    id: "hkern472"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "I",
    k: 20,
    id: "hkern473"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "?",
    k: 15,
    id: "hkern474"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC6",
    k: 52,
    id: "hkern475"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC5",
    k: 52,
    id: "hkern476"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC4",
    k: 52,
    id: "hkern477"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC3",
    k: 52,
    id: "hkern478"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC2",
    k: 52,
    id: "hkern479"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC1",
    k: 52,
    id: "hkern480"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\\xC0",
    k: 52,
    id: "hkern481"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "Z",
    k: 40,
    id: "hkern482"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "A",
    k: 52,
    id: "hkern483"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\\xFD",
    k: 10,
    id: "hkern484"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "y",
    k: 10,
    id: "hkern485"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "w",
    k: 10,
    id: "hkern486"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "v",
    k: 10,
    id: "hkern487"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\u0153",
    k: 15,
    id: "hkern488"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\u0152",
    k: 15,
    id: "hkern489"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xFD",
    k: 20,
    id: "hkern490"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xD6",
    k: 15,
    id: "hkern491"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xD5",
    k: 15,
    id: "hkern492"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xD4",
    k: 15,
    id: "hkern493"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xD3",
    k: 15,
    id: "hkern494"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xD2",
    k: 15,
    id: "hkern495"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\\xC7",
    k: 15,
    id: "hkern496"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "y",
    k: 20,
    id: "hkern497"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "w",
    k: 20,
    id: "hkern498"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "v",
    k: 20,
    id: "hkern499"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "q",
    k: 15,
    id: "hkern500"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "o",
    k: 15,
    id: "hkern501"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "g",
    k: 15,
    id: "hkern502"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "e",
    k: 15,
    id: "hkern503"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "d",
    k: 15,
    id: "hkern504"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "c",
    k: 15,
    id: "hkern505"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "a",
    k: 15,
    id: "hkern506"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "Q",
    k: 15,
    id: "hkern507"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "O",
    k: 15,
    id: "hkern508"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "G",
    k: 15,
    id: "hkern509"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "C",
    k: 15,
    id: "hkern510"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "B",
    k: -10,
    id: "hkern511"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\u0153",
    k: 30,
    id: "hkern512"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xDD",
    k: -15,
    id: "hkern513"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 30,
    id: "hkern514"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "o",
    k: 30,
    id: "hkern515"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "g",
    k: 30,
    id: "hkern516"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "e",
    k: 30,
    id: "hkern517"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "c",
    k: 30,
    id: "hkern518"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "a",
    k: 30,
    id: "hkern519"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Y",
    k: -15,
    id: "hkern520"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "W",
    k: -15,
    id: "hkern521"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "V",
    k: -15,
    id: "hkern522"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "T",
    k: -15,
    id: "hkern523"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 60,
    id: "hkern524"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "O",
    k: 50,
    id: "hkern525"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "G",
    k: 60,
    id: "hkern526"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\u0152",
    k: 65,
    id: "hkern527"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xFD",
    k: 30,
    id: "hkern528"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xD6",
    k: 65,
    id: "hkern529"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xD5",
    k: 65,
    id: "hkern530"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xD4",
    k: 65,
    id: "hkern531"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xD3",
    k: 65,
    id: "hkern532"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xD2",
    k: 65,
    id: "hkern533"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\\xC7",
    k: 65,
    id: "hkern534"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "y",
    k: 30,
    id: "hkern535"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "w",
    k: 49,
    id: "hkern536"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "v",
    k: 30,
    id: "hkern537"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "d",
    k: 45,
    id: "hkern538"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "C",
    k: 65,
    id: "hkern539"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\u0153",
    k: 35,
    id: "hkern540"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xDD",
    k: 80,
    id: "hkern541"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "q",
    k: 35,
    id: "hkern542"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "o",
    k: 35,
    id: "hkern543"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "g",
    k: 35,
    id: "hkern544"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "e",
    k: 35,
    id: "hkern545"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "c",
    k: 35,
    id: "hkern546"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "a",
    k: 35,
    id: "hkern547"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Y",
    k: 100,
    id: "hkern548"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 80,
    id: "hkern549"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "T",
    k: 80,
    id: "hkern550"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\u0152",
    k: 46,
    id: "hkern551"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xFD",
    k: 50,
    id: "hkern552"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xD6",
    k: 46,
    id: "hkern553"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xD5",
    k: 46,
    id: "hkern554"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xD4",
    k: 46,
    id: "hkern555"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xD3",
    k: 46,
    id: "hkern556"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xD2",
    k: 46,
    id: "hkern557"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\\xC7",
    k: 46,
    id: "hkern558"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "y",
    k: 50,
    id: "hkern559"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "w",
    k: 61,
    id: "hkern560"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 50,
    id: "hkern561"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "t",
    k: 43,
    id: "hkern562"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "d",
    k: 40,
    id: "hkern563"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "W",
    k: 70,
    id: "hkern564"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "Q",
    k: 64,
    id: "hkern565"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "O",
    k: 49,
    id: "hkern566"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "G",
    k: 62,
    id: "hkern567"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "C",
    k: 46,
    id: "hkern568"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\\u0153",
    k: 10,
    id: "hkern569"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "\\xDD",
    k: 30,
    id: "hkern570"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "q",
    k: 10,
    id: "hkern571"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "o",
    k: 10,
    id: "hkern572"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "g",
    k: 10,
    id: "hkern573"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "e",
    k: 10,
    id: "hkern574"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "d",
    k: 10,
    id: "hkern575"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "c",
    k: 10,
    id: "hkern576"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "a",
    k: 10,
    id: "hkern577"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "Y",
    k: 30,
    id: "hkern578"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "W",
    k: 30,
    id: "hkern579"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "M",
    u2: "V",
    k: 30,
    id: "hkern580"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\\xDD",
    k: 45,
    id: "hkern581"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "s",
    k: 15,
    id: "hkern582"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Z",
    k: 30,
    id: "hkern583"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "Y",
    k: 45,
    id: "hkern584"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 68,
    id: "hkern585"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "W",
    k: 45,
    id: "hkern586"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 45,
    id: "hkern587"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "T",
    k: 40,
    id: "hkern588"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "J",
    k: 20,
    id: "hkern589"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "I",
    k: 20,
    id: "hkern590"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "?",
    k: 15,
    id: "hkern591"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\u0153",
    k: 30,
    id: "hkern592"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC6",
    k: 72,
    id: "hkern593"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC5",
    k: 72,
    id: "hkern594"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC4",
    k: 72,
    id: "hkern595"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC3",
    k: 72,
    id: "hkern596"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC2",
    k: 72,
    id: "hkern597"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC1",
    k: 72,
    id: "hkern598"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xC0",
    k: 72,
    id: "hkern599"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 30,
    id: "hkern600"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 30,
    id: "hkern601"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 30,
    id: "hkern602"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 30,
    id: "hkern603"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 30,
    id: "hkern604"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 30,
    id: "hkern605"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 30,
    id: "hkern606"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 20,
    id: "hkern607"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 72,
    id: "hkern608"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 60,
    id: "hkern609"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 60,
    id: "hkern610"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\\xDD",
    k: 20,
    id: "hkern611"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 20,
    id: "hkern612"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 20,
    id: "hkern613"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 20,
    id: "hkern614"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 48,
    id: "hkern615"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\\u0153",
    k: 12,
    id: "hkern616"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "q",
    k: 12,
    id: "hkern617"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "o",
    k: 12,
    id: "hkern618"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "g",
    k: 12,
    id: "hkern619"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "e",
    k: 12,
    id: "hkern620"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "d",
    k: 12,
    id: "hkern621"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "c",
    k: 12,
    id: "hkern622"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "a",
    k: 12,
    id: "hkern623"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 80,
    id: "hkern624"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\\xDD",
    k: 73,
    id: "hkern625"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "u",
    k: 10,
    id: "hkern626"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "W",
    k: 73,
    id: "hkern627"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 73,
    id: "hkern628"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\\xDD",
    k: 15,
    id: "hkern629"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "Y",
    k: 15,
    id: "hkern630"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "W",
    k: 15,
    id: "hkern631"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 15,
    id: "hkern632"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\\u0153",
    k: 25,
    id: "hkern633"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "q",
    k: 25,
    id: "hkern634"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "o",
    k: 25,
    id: "hkern635"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "g",
    k: 25,
    id: "hkern636"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "e",
    k: 25,
    id: "hkern637"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "d",
    k: 25,
    id: "hkern638"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "c",
    k: 25,
    id: "hkern639"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "a",
    k: 25,
    id: "hkern640"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\\xFD",
    k: 10,
    id: "hkern641"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\\xDD",
    k: 15,
    id: "hkern642"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "y",
    k: 10,
    id: "hkern643"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "x",
    k: 15,
    id: "hkern644"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "w",
    k: 10,
    id: "hkern645"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "v",
    k: 10,
    id: "hkern646"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "W",
    k: 15,
    id: "hkern647"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 15,
    id: "hkern648"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "Y",
    k: 47,
    id: "hkern649"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\u2014",
    k: 60,
    id: "hkern650"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\u2013",
    k: 60,
    id: "hkern651"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\u0153",
    k: 90,
    id: "hkern652"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\u0152",
    k: 40,
    id: "hkern653"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xD6",
    k: 40,
    id: "hkern654"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xD5",
    k: 40,
    id: "hkern655"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xD4",
    k: 40,
    id: "hkern656"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xD3",
    k: 40,
    id: "hkern657"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xD2",
    k: 40,
    id: "hkern658"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC7",
    k: 40,
    id: "hkern659"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC6",
    k: 55,
    id: "hkern660"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC5",
    k: 55,
    id: "hkern661"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC4",
    k: 55,
    id: "hkern662"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC3",
    k: 55,
    id: "hkern663"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC2",
    k: 55,
    id: "hkern664"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC1",
    k: 55,
    id: "hkern665"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xC0",
    k: 55,
    id: "hkern666"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "y",
    k: 50,
    id: "hkern667"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "s",
    k: 80,
    id: "hkern668"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "r",
    k: 100,
    id: "hkern669"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "o",
    k: 112,
    id: "hkern670"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "n",
    k: 100,
    id: "hkern671"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "g",
    k: 126,
    id: "hkern672"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "e",
    k: 90,
    id: "hkern673"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "d",
    k: 90,
    id: "hkern674"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "c",
    k: 90,
    id: "hkern675"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "a",
    k: 90,
    id: "hkern676"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "Q",
    k: 40,
    id: "hkern677"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "O",
    k: 30,
    id: "hkern678"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "M",
    k: 25,
    id: "hkern679"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "G",
    k: 40,
    id: "hkern680"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "C",
    k: 40,
    id: "hkern681"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "A",
    k: 55,
    id: "hkern682"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "-",
    k: 60,
    id: "hkern683"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\\xFD",
    k: 84,
    id: "hkern684"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "z",
    k: 89,
    id: "hkern685"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 85,
    id: "hkern686"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "w",
    k: 84,
    id: "hkern687"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "v",
    k: 84,
    id: "hkern688"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "u",
    k: 80,
    id: "hkern689"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 126,
    id: "hkern690"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 128,
    id: "hkern691"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "m",
    k: 128,
    id: "hkern692"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 126,
    id: "hkern693"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\\xDD",
    k: -10,
    id: "hkern694"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "Y",
    k: -10,
    id: "hkern695"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "W",
    k: -10,
    id: "hkern696"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "V",
    k: -10,
    id: "hkern697"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\u0152",
    k: 54,
    id: "hkern698"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xD6",
    k: 54,
    id: "hkern699"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xD5",
    k: 54,
    id: "hkern700"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xD4",
    k: 54,
    id: "hkern701"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xD3",
    k: 54,
    id: "hkern702"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xD2",
    k: 54,
    id: "hkern703"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\\xC7",
    k: 54,
    id: "hkern704"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 81,
    id: "hkern705"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 70,
    id: "hkern706"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 68,
    id: "hkern707"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 90,
    id: "hkern708"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 80,
    id: "hkern709"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 15,
    id: "hkern710"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 54,
    id: "hkern711"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 54,
    id: "hkern712"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "M",
    k: 30,
    id: "hkern713"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 54,
    id: "hkern714"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 54,
    id: "hkern715"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 100,
    id: "hkern716"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 41,
    id: "hkern717"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 68,
    id: "hkern718"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 56,
    id: "hkern719"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "t",
    k: 54,
    id: "hkern720"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 92,
    id: "hkern721"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 64,
    id: "hkern722"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 118,
    id: "hkern723"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 64,
    id: "hkern724"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 64,
    id: "hkern725"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 64,
    id: "hkern726"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 118,
    id: "hkern727"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 131,
    id: "hkern728"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 103,
    id: "hkern729"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "U",
    k: -10,
    id: "hkern730"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 117,
    id: "hkern731"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC6",
    k: 50,
    id: "hkern732"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC5",
    k: 50,
    id: "hkern733"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC4",
    k: 50,
    id: "hkern734"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC3",
    k: 50,
    id: "hkern735"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC2",
    k: 50,
    id: "hkern736"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC1",
    k: 50,
    id: "hkern737"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\xC0",
    k: 50,
    id: "hkern738"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "x",
    k: 81,
    id: "hkern739"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "w",
    k: 70,
    id: "hkern740"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "v",
    k: 68,
    id: "hkern741"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "s",
    k: 19,
    id: "hkern742"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "o",
    k: 53,
    id: "hkern743"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "S",
    k: 15,
    id: "hkern744"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "O",
    k: 30,
    id: "hkern745"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "M",
    k: 30,
    id: "hkern746"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 117,
    id: "hkern747"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "G",
    k: 50,
    id: "hkern748"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "A",
    k: 50,
    id: "hkern749"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 100,
    id: "hkern750"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\\u0153",
    k: 53,
    id: "hkern751"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "z",
    k: 41,
    id: "hkern752"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "y",
    k: 68,
    id: "hkern753"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "u",
    k: 56,
    id: "hkern754"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "t",
    k: 54,
    id: "hkern755"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "r",
    k: 64,
    id: "hkern756"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 53,
    id: "hkern757"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 64,
    id: "hkern758"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "n",
    k: 64,
    id: "hkern759"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "m",
    k: 64,
    id: "hkern760"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "g",
    k: 53,
    id: "hkern761"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "e",
    k: 53,
    id: "hkern762"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "d",
    k: 53,
    id: "hkern763"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "c",
    k: 53,
    id: "hkern764"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "a",
    k: 53,
    id: "hkern765"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "U",
    k: -10,
    id: "hkern766"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "Q",
    k: 69,
    id: "hkern767"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "C",
    k: 52,
    id: "hkern768"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\u0153",
    k: 30,
    id: "hkern769"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 12,
    id: "hkern770"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 30,
    id: "hkern771"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 30,
    id: "hkern772"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 30,
    id: "hkern773"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 30,
    id: "hkern774"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 30,
    id: "hkern775"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 30,
    id: "hkern776"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 68,
    id: "hkern777"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 81,
    id: "hkern778"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\u0152",
    k: 65,
    id: "hkern779"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xFD",
    k: 43,
    id: "hkern780"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xD6",
    k: 65,
    id: "hkern781"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xD5",
    k: 65,
    id: "hkern782"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xD4",
    k: 65,
    id: "hkern783"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xD3",
    k: 65,
    id: "hkern784"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xD2",
    k: 65,
    id: "hkern785"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\\xC7",
    k: 65,
    id: "hkern786"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 43,
    id: "hkern787"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 43,
    id: "hkern788"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 43,
    id: "hkern789"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 50,
    id: "hkern790"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 83,
    id: "hkern791"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 65,
    id: "hkern792"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\u0153",
    k: 120,
    id: "hkern793"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\u0152",
    k: 60,
    id: "hkern794"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xD6",
    k: 60,
    id: "hkern795"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xD5",
    k: 60,
    id: "hkern796"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xD4",
    k: 60,
    id: "hkern797"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xD3",
    k: 60,
    id: "hkern798"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xD2",
    k: 60,
    id: "hkern799"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC7",
    k: 60,
    id: "hkern800"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC6",
    k: 100,
    id: "hkern801"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC5",
    k: 100,
    id: "hkern802"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC4",
    k: 100,
    id: "hkern803"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC3",
    k: 100,
    id: "hkern804"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC2",
    k: 100,
    id: "hkern805"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC1",
    k: 100,
    id: "hkern806"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\\xC0",
    k: 100,
    id: "hkern807"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "z",
    k: 90,
    id: "hkern808"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 81,
    id: "hkern809"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "w",
    k: 70,
    id: "hkern810"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "v",
    k: 68,
    id: "hkern811"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "u",
    k: 105,
    id: "hkern812"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "s",
    k: 120,
    id: "hkern813"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 120,
    id: "hkern814"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 113,
    id: "hkern815"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "o",
    k: 120,
    id: "hkern816"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "n",
    k: 90,
    id: "hkern817"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "m",
    k: 90,
    id: "hkern818"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "g",
    k: 120,
    id: "hkern819"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "e",
    k: 120,
    id: "hkern820"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "d",
    k: 120,
    id: "hkern821"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "a",
    k: 120,
    id: "hkern822"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 80,
    id: "hkern823"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "O",
    k: 45,
    id: "hkern824"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "M",
    k: 30,
    id: "hkern825"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "G",
    k: 80,
    id: "hkern826"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "C",
    k: 60,
    id: "hkern827"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "A",
    k: 100,
    id: "hkern828"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 100,
    id: "hkern829"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "y",
    k: 68,
    id: "hkern830"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "t",
    k: 54,
    id: "hkern831"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "r",
    k: 113,
    id: "hkern832"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "c",
    k: 120,
    id: "hkern833"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "U",
    k: -10,
    id: "hkern834"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "S",
    k: 43,
    id: "hkern835"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 181,
    id: "hkern836"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\u0153",
    k: 35,
    id: "hkern837"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\u0152",
    k: 30,
    id: "hkern838"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xFD",
    k: 25,
    id: "hkern839"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xD6",
    k: 30,
    id: "hkern840"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xD5",
    k: 30,
    id: "hkern841"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xD4",
    k: 30,
    id: "hkern842"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xD3",
    k: 30,
    id: "hkern843"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xD2",
    k: 30,
    id: "hkern844"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\\xC7",
    k: 30,
    id: "hkern845"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "y",
    k: 25,
    id: "hkern846"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "w",
    k: 25,
    id: "hkern847"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "v",
    k: 25,
    id: "hkern848"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "q",
    k: 35,
    id: "hkern849"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "o",
    k: 35,
    id: "hkern850"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "g",
    k: 35,
    id: "hkern851"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "e",
    k: 35,
    id: "hkern852"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "d",
    k: 35,
    id: "hkern853"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "c",
    k: 35,
    id: "hkern854"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "a",
    k: 35,
    id: "hkern855"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "O",
    k: 30,
    id: "hkern856"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "G",
    k: 30,
    id: "hkern857"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "C",
    k: 30,
    id: "hkern858"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "Q",
    k: 41,
    id: "hkern859"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "T",
    k: 35,
    id: "hkern860"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 50,
    id: "hkern861"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 25,
    id: "hkern862"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "t",
    k: 30,
    id: "hkern863"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "s",
    k: 10,
    id: "hkern864"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "j",
    k: 15,
    id: "hkern865"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "i",
    k: 10,
    id: "hkern866"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "c",
    k: 10,
    id: "hkern867"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "T",
    k: 40,
    id: "hkern868"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 50,
    id: "hkern869"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "z",
    k: 25,
    id: "hkern870"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "y",
    k: 15,
    id: "hkern871"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 25,
    id: "hkern872"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "t",
    k: 30,
    id: "hkern873"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "s",
    k: 10,
    id: "hkern874"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "j",
    k: 15,
    id: "hkern875"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "i",
    k: 10,
    id: "hkern876"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "c",
    k: 10,
    id: "hkern877"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "T",
    k: 40,
    id: "hkern878"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 50,
    id: "hkern879"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "z",
    k: 25,
    id: "hkern880"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "y",
    k: 15,
    id: "hkern881"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 25,
    id: "hkern882"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "t",
    k: 30,
    id: "hkern883"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "s",
    k: 10,
    id: "hkern884"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "j",
    k: 15,
    id: "hkern885"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "i",
    k: 10,
    id: "hkern886"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "c",
    k: 10,
    id: "hkern887"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "T",
    k: 40,
    id: "hkern888"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 50,
    id: "hkern889"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "z",
    k: 25,
    id: "hkern890"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "y",
    k: 15,
    id: "hkern891"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "s",
    k: 15,
    id: "hkern892"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\\u0153",
    k: 30,
    id: "hkern893"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 30,
    id: "hkern894"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "o",
    k: 30,
    id: "hkern895"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 30,
    id: "hkern896"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "e",
    k: 30,
    id: "hkern897"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 30,
    id: "hkern898"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "c",
    k: 30,
    id: "hkern899"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "a",
    k: 30,
    id: "hkern900"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\\u0153",
    k: 10,
    id: "hkern901"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "q",
    k: 10,
    id: "hkern902"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "o",
    k: 10,
    id: "hkern903"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "g",
    k: 10,
    id: "hkern904"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "e",
    k: 10,
    id: "hkern905"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "d",
    k: 10,
    id: "hkern906"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "c",
    k: 10,
    id: "hkern907"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "a",
    k: 10,
    id: "hkern908"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -20,
    id: "hkern909"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\\u0153",
    k: 25,
    id: "hkern910"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 25,
    id: "hkern911"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 25,
    id: "hkern912"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "g",
    k: 25,
    id: "hkern913"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "e",
    k: 25,
    id: "hkern914"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 25,
    id: "hkern915"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "c",
    k: 25,
    id: "hkern916"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "a",
    k: 25,
    id: "hkern917"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 25,
    id: "hkern918"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "t",
    k: 30,
    id: "hkern919"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "s",
    k: 10,
    id: "hkern920"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "j",
    k: 15,
    id: "hkern921"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "i",
    k: 10,
    id: "hkern922"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "c",
    k: 10,
    id: "hkern923"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "T",
    k: 40,
    id: "hkern924"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 50,
    id: "hkern925"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "z",
    k: 25,
    id: "hkern926"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "y",
    k: 15,
    id: "hkern927"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 25,
    id: "hkern928"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "t",
    k: 30,
    id: "hkern929"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "s",
    k: 10,
    id: "hkern930"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "j",
    k: 15,
    id: "hkern931"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "i",
    k: 10,
    id: "hkern932"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "c",
    k: 10,
    id: "hkern933"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "T",
    k: 40,
    id: "hkern934"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 50,
    id: "hkern935"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "z",
    k: 25,
    id: "hkern936"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "y",
    k: 15,
    id: "hkern937"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\\xFD",
    k: -25,
    id: "hkern938"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "y",
    k: -25,
    id: "hkern939"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "w",
    k: -25,
    id: "hkern940"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "v",
    k: -25,
    id: "hkern941"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "p",
    k: -30,
    id: "hkern942"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -150,
    id: "hkern943"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\\u0153",
    k: 10,
    id: "hkern944"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "t",
    k: 10,
    id: "hkern945"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "q",
    k: 10,
    id: "hkern946"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "o",
    k: 10,
    id: "hkern947"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "g",
    k: 10,
    id: "hkern948"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "e",
    k: 10,
    id: "hkern949"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "d",
    k: 10,
    id: "hkern950"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "c",
    k: 10,
    id: "hkern951"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "a",
    k: 10,
    id: "hkern952"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\\xFD",
    k: 10,
    id: "hkern953"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "y",
    k: 10,
    id: "hkern954"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "w",
    k: 10,
    id: "hkern955"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "v",
    k: 10,
    id: "hkern956"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\\u2014",
    k: 50,
    id: "hkern957"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\\u2013",
    k: 50,
    id: "hkern958"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\\u0153",
    k: 30,
    id: "hkern959"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "s",
    k: 10,
    id: "hkern960"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "q",
    k: 30,
    id: "hkern961"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "o",
    k: 30,
    id: "hkern962"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "g",
    k: 30,
    id: "hkern963"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "e",
    k: 30,
    id: "hkern964"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "d",
    k: 30,
    id: "hkern965"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "c",
    k: 30,
    id: "hkern966"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "a",
    k: 30,
    id: "hkern967"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ".",
    k: 25,
    id: "hkern968"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "-",
    k: 50,
    id: "hkern969"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ",",
    k: 25,
    id: "hkern970"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "k",
    k: 15,
    id: "hkern971"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "s",
    k: 10,
    id: "hkern972"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "k",
    k: 15,
    id: "hkern973"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "s",
    k: 10,
    id: "hkern974"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\\u0153",
    k: 25,
    id: "hkern975"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "s",
    k: 20,
    id: "hkern976"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 25,
    id: "hkern977"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 25,
    id: "hkern978"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 25,
    id: "hkern979"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 25,
    id: "hkern980"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 25,
    id: "hkern981"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 25,
    id: "hkern982"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "a",
    k: 25,
    id: "hkern983"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "k",
    k: 15,
    id: "hkern984"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "s",
    k: 10,
    id: "hkern985"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xA3",
    u2: 7,
    k: 15,
    id: "hkern986"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xA3",
    u2: 9,
    k: 15,
    id: "hkern987"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xA3",
    u2: 5,
    k: 20,
    id: "hkern988"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xA3",
    u2: 0,
    k: 10,
    id: "hkern989"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\u0152",
    k: 80,
    id: "hkern990"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xD6",
    k: 80,
    id: "hkern991"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xD5",
    k: 80,
    id: "hkern992"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xD4",
    k: 80,
    id: "hkern993"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xD3",
    k: 80,
    id: "hkern994"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xD2",
    k: 80,
    id: "hkern995"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "\\xC7",
    k: 80,
    id: "hkern996"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "Q",
    k: 80,
    id: "hkern997"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "O",
    k: 80,
    id: "hkern998"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "G",
    k: 80,
    id: "hkern999"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xBF",
    u2: "C",
    k: 80,
    id: "hkern1000"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "Y",
    k: 100,
    id: "hkern1001"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "W",
    k: 50,
    id: "hkern1002"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "V",
    k: 100,
    id: "hkern1003"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "S",
    k: 30,
    id: "hkern1004"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "\\xAE",
    k: 30,
    id: "hkern1005"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "w",
    k: 47,
    id: "hkern1006"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "T",
    k: 92,
    id: "hkern1007"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "Q",
    k: 50,
    id: "hkern1008"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "G",
    k: 48,
    id: "hkern1009"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC0",
    u2: "?",
    k: 50,
    id: "hkern1010"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "Y",
    k: 100,
    id: "hkern1011"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "W",
    k: 50,
    id: "hkern1012"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "V",
    k: 100,
    id: "hkern1013"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "S",
    k: 30,
    id: "hkern1014"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "\\xAE",
    k: 30,
    id: "hkern1015"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "w",
    k: 47,
    id: "hkern1016"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "T",
    k: 92,
    id: "hkern1017"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "Q",
    k: 50,
    id: "hkern1018"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "G",
    k: 48,
    id: "hkern1019"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC1",
    u2: "?",
    k: 50,
    id: "hkern1020"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "Y",
    k: 100,
    id: "hkern1021"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "W",
    k: 50,
    id: "hkern1022"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "V",
    k: 100,
    id: "hkern1023"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "S",
    k: 30,
    id: "hkern1024"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "\\xAE",
    k: 30,
    id: "hkern1025"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "w",
    k: 47,
    id: "hkern1026"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "T",
    k: 92,
    id: "hkern1027"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "Q",
    k: 50,
    id: "hkern1028"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "G",
    k: 48,
    id: "hkern1029"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC2",
    u2: "?",
    k: 50,
    id: "hkern1030"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "Y",
    k: 100,
    id: "hkern1031"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "W",
    k: 50,
    id: "hkern1032"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "V",
    k: 100,
    id: "hkern1033"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "S",
    k: 30,
    id: "hkern1034"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "\\xAE",
    k: 30,
    id: "hkern1035"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "w",
    k: 47,
    id: "hkern1036"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "T",
    k: 92,
    id: "hkern1037"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "Q",
    k: 50,
    id: "hkern1038"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "G",
    k: 48,
    id: "hkern1039"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC3",
    u2: "?",
    k: 50,
    id: "hkern1040"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "Y",
    k: 100,
    id: "hkern1041"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "W",
    k: 50,
    id: "hkern1042"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "V",
    k: 100,
    id: "hkern1043"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "S",
    k: 30,
    id: "hkern1044"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "\\xAE",
    k: 30,
    id: "hkern1045"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "w",
    k: 47,
    id: "hkern1046"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "T",
    k: 92,
    id: "hkern1047"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "Q",
    k: 50,
    id: "hkern1048"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "G",
    k: 48,
    id: "hkern1049"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC4",
    u2: "?",
    k: 50,
    id: "hkern1050"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "Y",
    k: 100,
    id: "hkern1051"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "W",
    k: 50,
    id: "hkern1052"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "V",
    k: 100,
    id: "hkern1053"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "S",
    k: 30,
    id: "hkern1054"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "\\xAE",
    k: 30,
    id: "hkern1055"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "w",
    k: 47,
    id: "hkern1056"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "T",
    k: 92,
    id: "hkern1057"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "Q",
    k: 50,
    id: "hkern1058"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "G",
    k: 48,
    id: "hkern1059"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC5",
    u2: "?",
    k: 50,
    id: "hkern1060"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "s",
    k: 15,
    id: "hkern1061"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "Z",
    k: 30,
    id: "hkern1062"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "V",
    k: 63,
    id: "hkern1063"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "T",
    k: 25,
    id: "hkern1064"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "J",
    k: 20,
    id: "hkern1065"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "I",
    k: 20,
    id: "hkern1066"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "?",
    k: 15,
    id: "hkern1067"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "Y",
    k: 93,
    id: "hkern1068"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xC7",
    u2: "X",
    k: 75,
    id: "hkern1069"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "s",
    k: 15,
    id: "hkern1070"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "Z",
    k: 30,
    id: "hkern1071"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "V",
    k: 63,
    id: "hkern1072"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "T",
    k: 25,
    id: "hkern1073"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "J",
    k: 20,
    id: "hkern1074"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "I",
    k: 20,
    id: "hkern1075"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "?",
    k: 15,
    id: "hkern1076"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "Y",
    k: 93,
    id: "hkern1077"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD2",
    u2: "X",
    k: 75,
    id: "hkern1078"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "s",
    k: 15,
    id: "hkern1079"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "Z",
    k: 30,
    id: "hkern1080"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "V",
    k: 63,
    id: "hkern1081"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "T",
    k: 25,
    id: "hkern1082"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "J",
    k: 20,
    id: "hkern1083"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "I",
    k: 20,
    id: "hkern1084"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "?",
    k: 15,
    id: "hkern1085"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "Y",
    k: 93,
    id: "hkern1086"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD3",
    u2: "X",
    k: 75,
    id: "hkern1087"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "s",
    k: 15,
    id: "hkern1088"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "Z",
    k: 30,
    id: "hkern1089"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "V",
    k: 63,
    id: "hkern1090"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "T",
    k: 25,
    id: "hkern1091"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "J",
    k: 20,
    id: "hkern1092"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "I",
    k: 20,
    id: "hkern1093"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "?",
    k: 15,
    id: "hkern1094"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "Y",
    k: 93,
    id: "hkern1095"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD4",
    u2: "X",
    k: 75,
    id: "hkern1096"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "s",
    k: 15,
    id: "hkern1097"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "Z",
    k: 30,
    id: "hkern1098"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "V",
    k: 63,
    id: "hkern1099"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "T",
    k: 25,
    id: "hkern1100"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "J",
    k: 20,
    id: "hkern1101"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "I",
    k: 20,
    id: "hkern1102"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "?",
    k: 15,
    id: "hkern1103"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "Y",
    k: 93,
    id: "hkern1104"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD5",
    u2: "X",
    k: 75,
    id: "hkern1105"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "s",
    k: 15,
    id: "hkern1106"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "Z",
    k: 30,
    id: "hkern1107"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "V",
    k: 63,
    id: "hkern1108"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "T",
    k: 25,
    id: "hkern1109"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "J",
    k: 20,
    id: "hkern1110"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "I",
    k: 20,
    id: "hkern1111"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "?",
    k: 15,
    id: "hkern1112"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "Y",
    k: 93,
    id: "hkern1113"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xD6",
    u2: "X",
    k: 75,
    id: "hkern1114"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "x",
    k: 81,
    id: "hkern1115"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "w",
    k: 70,
    id: "hkern1116"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "v",
    k: 68,
    id: "hkern1117"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "s",
    k: 19,
    id: "hkern1118"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "o",
    k: 90,
    id: "hkern1119"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "a",
    k: 80,
    id: "hkern1120"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "S",
    k: 15,
    id: "hkern1121"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "O",
    k: 30,
    id: "hkern1122"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "M",
    k: 30,
    id: "hkern1123"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "J",
    k: 117,
    id: "hkern1124"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "G",
    k: 50,
    id: "hkern1125"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: ".",
    k: 100,
    id: "hkern1126"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "z",
    k: 41,
    id: "hkern1127"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "y",
    k: 68,
    id: "hkern1128"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "u",
    k: 56,
    id: "hkern1129"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "t",
    k: 54,
    id: "hkern1130"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "r",
    k: 64,
    id: "hkern1131"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "q",
    k: 118,
    id: "hkern1132"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "p",
    k: 64,
    id: "hkern1133"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "n",
    k: 64,
    id: "hkern1134"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "m",
    k: 64,
    id: "hkern1135"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "g",
    k: 118,
    id: "hkern1136"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "d",
    k: 131,
    id: "hkern1137"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "c",
    k: 103,
    id: "hkern1138"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "U",
    k: -10,
    id: "hkern1139"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "Q",
    k: 69,
    id: "hkern1140"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xDD",
    u2: "C",
    k: 52,
    id: "hkern1141"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xFD",
    u2: "k",
    k: 15,
    id: "hkern1142"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\xFD",
    u2: "s",
    k: 10,
    id: "hkern1143"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "\\u0142",
    k: -60,
    id: "hkern1144"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "\\u013E",
    k: -60,
    id: "hkern1145"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "\\u013C",
    k: -60,
    id: "hkern1146"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "\\u013A",
    k: -60,
    id: "hkern1147"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "\\u0127",
    k: -60,
    id: "hkern1148"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "l",
    k: -60,
    id: "hkern1149"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "k",
    k: -60,
    id: "hkern1150"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "h",
    k: -60,
    id: "hkern1151"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "f",
    k: -60,
    id: "hkern1152"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u010F",
    u2: "b",
    k: -60,
    id: "hkern1153"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "x",
    k: 25,
    id: "hkern1154"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "t",
    k: 30,
    id: "hkern1155"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "s",
    k: 10,
    id: "hkern1156"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "j",
    k: 15,
    id: "hkern1157"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "i",
    k: 10,
    id: "hkern1158"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "c",
    k: 10,
    id: "hkern1159"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "T",
    k: 40,
    id: "hkern1160"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "?",
    k: 50,
    id: "hkern1161"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "z",
    k: 25,
    id: "hkern1162"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u0153",
    u2: "y",
    k: 15,
    id: "hkern1163"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2013",
    u2: 2,
    k: 25,
    id: "hkern1164"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2013",
    u2: "t",
    k: 50,
    id: "hkern1165"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2013",
    u2: "T",
    k: 60,
    id: "hkern1166"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2014",
    u2: 2,
    k: 25,
    id: "hkern1167"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2014",
    u2: "t",
    k: 50,
    id: "hkern1168"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2014",
    u2: "T",
    k: 60,
    id: "hkern1169"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xDD",
    k: 20,
    id: "hkern1170"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC6",
    k: 25,
    id: "hkern1171"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC5",
    k: 25,
    id: "hkern1172"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC4",
    k: 25,
    id: "hkern1173"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC3",
    k: 25,
    id: "hkern1174"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC2",
    k: 25,
    id: "hkern1175"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC1",
    k: 25,
    id: "hkern1176"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "\\xC0",
    k: 25,
    id: "hkern1177"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "Y",
    k: 20,
    id: "hkern1178"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "W",
    k: 20,
    id: "hkern1179"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "V",
    k: 20,
    id: "hkern1180"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "T",
    k: 20,
    id: "hkern1181"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\u2022",
    u2: "A",
    k: 25,
    id: "hkern1182"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,OE",
    k: 5,
    id: "hkern1183"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE",
    k: 43,
    id: "hkern1184"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis",
    g2: "a,c,d,e,g,o,q,oe",
    k: 15,
    id: "hkern1185"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis",
    g2: "V,W,Y,Yacute",
    k: 30,
    id: "hkern1186"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,G,O,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis",
    g2: "comma,period",
    k: 30,
    id: "hkern1187"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,OE",
    k: 43,
    id: "hkern1188"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "a,c,d,e,g,o,q,oe",
    k: 25,
    id: "hkern1189"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V,W,Y,Yacute",
    k: 50,
    id: "hkern1190"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v,w,y,yacute",
    k: 30,
    id: "hkern1191"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,c,e,o,p,oe",
    g2: "a,c,d,e,g,o,q,oe",
    k: 15,
    id: "hkern1192"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,c,e,o,p,oe",
    g2: "v,w,y,yacute",
    k: 15,
    id: "hkern1193"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,OE",
    k: 10,
    id: "hkern1194"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE",
    k: 100,
    id: "hkern1195"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "a,c,d,e,g,o,q,oe",
    k: 25,
    id: "hkern1196"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "V,W,Y,Yacute",
    k: -10,
    id: "hkern1197"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "v,w,y,yacute",
    k: 20,
    id: "hkern1198"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "hyphen,endash,emdash",
    k: 50,
    id: "hkern1199"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Y,Yacute",
    g2: "comma,period",
    k: 60,
    id: "hkern1200"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute",
    g2: "a,c,d,e,g,o,q,oe",
    k: 15,
    id: "hkern1201"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute",
    g2: "hyphen,endash,emdash",
    k: 40,
    id: "hkern1202"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute",
    g2: "comma,period",
    k: 20,
    id: "hkern1203"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "V,W,Y,Yacute",
    k: 50,
    id: "hkern1204"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,OE",
    k: 25,
    id: "hkern1205"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period",
    g2: "V,W,Y,Yacute",
    k: 60,
    id: "hkern1206"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period",
    g2: "v,w,y,yacute",
    k: 50,
    id: "hkern1207"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1909.8351,3907.841 c -3.7665,-1.3906 -6.4651,-3.2246 -9.4455,-4.1028 -28.687,-8.4541 -49.522,-26.322 -64.15,-52.169 -7.9276,-14.007 -9.8804,-29.543 -12.759,-44.853 -0.7122,-3.7863 -0.097,-8.0744 0.8784,-11.883 4.3737,-17.072 8.8455,-34.221 19.024,-48.976 14.585,-21.143 33.545,-36.455 58.483,-44.366 35.344,-11.213 68.56,-4.2007 100.77,10.854 24.641,11.516 39.612,31.648 48.122,57.179 6.1702,18.512 6.417,37.699 4.2759,56.383 -2.3333,20.358 -13.92,36.963 -28.674,51.34 -14.187,13.824 -31.13,22.529 -49.456,29.852 -22.05,0.7422 -44.092,0.7422 -67.071,0.7422 z",
    fill: "#000aff",
    id: "path1207"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 3408.2351,2085.041 c -19.277,5.405 -36.292,13.746 -51.452,25.459 -21.423,16.554 -35.759,37.97 -44.27,63.847 -5.1553,15.674 -6.3977,31.167 -4.3076,47.231 3.3523,25.77 7.6159,51.464 9.7685,77.334 1.6197,19.467 3.0008,38.992 2.0965,58.752 -0.753,16.442 -4.6751,31.46 -10.576,46.327 -9.2679,23.35 -26.204,40.585 -45.103,56.32 -23.354,19.445 -50.76,28.637 -80.317,32.761 -5.9253,0.8264 -11.755,2.4548 -17.696,3.0346 -16.557,1.6153 -32.473,-2.5947 -48.217,-6.6545 -28,-7.2205 -52.958,-20.547 -72.226,-42.356 -23.266,-26.334 -37.406,-57.298 -42.298,-92.269 -1.5188,-10.856 -3.489,-21.693 -4.1472,-32.605 -0.3499,-5.8008 1.6286,-11.751 2.6277,-17.621 0.4453,-2.6152 1.1372,-5.1885 1.5974,-7.8015 2.4741,-14.048 5.3415,-28.045 7.2058,-42.175 1.2126,-9.1882 0.9323,-18.572 1.3427,-27.867 1.2564,-28.454 -9.1491,-53.472 -23.011,-77.4 -18.253,-31.509 -45.947,-51.063 -79.809,-62.929 -22.934,-8.0369 -46.412,-12.836 -70.645,-10.078 -50.249,5.7202 -92.167,25.817 -117.26,72.334 -6.1343,11.37 -11.052,23.494 -15.478,35.655 -3.1546,8.6668 -5.0327,17.895 -6.5196,27.03 -0.7185,4.4157 0.4058,9.2656 1.3245,13.791 5.4963,27.077 12.06,53.975 16.449,81.225 2.4685,15.324 3.4378,31.445 1.6287,46.8 -5.3804,45.66 -24.382,84.885 -60.765,114.23 -16.503,13.31 -35.482,22.213 -56.121,27.475 -32.148,8.1967 -64.697,10.076 -96.97,2.5734 -27.572,-6.4096 -52.137,-19.473 -73.035,-39.304 -23.543,-22.339 -41.446,-48.172 -48.834,-79.843 -4.3518,-18.654 -5.7138,-38.053 -7.6482,-57.194 -0.5451,-5.3955 1.5994,-11.074 2.5901,-16.608 0.3504,-1.9573 1.1468,-3.8467 1.3836,-5.81 1.6323,-13.524 3,-27.082 4.8078,-40.581 0.9649,-7.2056 3.0874,-14.266 3.8931,-21.481 1.5164,-13.577 -3.0825,-26.433 -6.3147,-39.24 -8.4336,-33.413 -24.559,-62.593 -51.235,-85.075 -7.5977,-6.4033 -15.764,-12.408 -24.439,-17.205 -25.776,-14.256 -53.769,-21.583 -83.086,-22.593 -10.455,-0.3601 -21.109,2.1514 -31.524,4.1318 -23.076,4.3885 -45.074,11.696 -64.584,25.356 -17.736,12.418 -32.346,27.68 -43.249,46.424 -9.6053,16.514 -17.025,33.873 -20.438,52.795 -0.4101,2.2744 -1.0908,4.5417 -1.9607,6.6846 -2.8884,7.1145 -2.8022,14.225 -0.7353,21.538 3.9848,14.102 7.6386,28.298 11.66,42.389 4.5051,15.787 7.4917,31.715 6.9031,48.257 -0.3672,10.318 -0.1585,20.668 0.095,30.995 0.7461,30.332 -7.4167,58.457 -25.124,82.594 -21.929,29.891 -50.197,52.458 -86.988,62.083 -21.942,5.7407 -44.18,10.35 -67.072,8.3599 -42.868,-3.7256 -82.75,-15.932 -114.29,-46.589 -20.463,-19.889 -35.271,-43.974 -44.856,-71.276 -10.9,-31.046 -10.308,-62.915 -8.3507,-94.892 0.4977,-8.1321 2.9598,-16.528 6.2622,-24.036 12.643,-28.745 12.873,-57.142 0.6608,-86.101 -6.4582,-15.314 -16.047,-28.376 -26.318,-41.06 -20.687,-25.545 -44.832,-46.51 -76.95,-56.573 -13.386,-4.1944 -26.882,-7.1897 -41.068,-7.7129 -31.133,-1.1482 -61.169,3.1709 -89.54,16.34 -8.6933,4.0349 -17.212,8.8215 -24.959,14.438 -13.82,10.019 -25.355,22.548 -35.955,35.925 -10.357,13.07 -15.224,28.664 -20.744,44.01 -6.0558,16.832 -5.4382,33.943 -3.2696,51.297 3.3874,27.108 6.9319,54.214 9.4005,81.412 1.4426,15.893 1.886,32.021 0.9394,47.934 -0.6015,10.113 -3.7004,20.348 -7.2302,29.959 -6.7777,18.455 -15.438,35.709 -29.051,50.726 -25.938,28.613 -58.582,42.879 -95.606,49.67 -39.112,7.1733 -76.45,1.5744 -111.65,-16.129 -42.279,-21.262 -70.296,-55.364 -84.763,-100.29 -7.7693,-24.126 -9.2466,-49.196 -6.1431,-74.185 1.7925,-14.434 5.358,-28.83 9.8016,-42.707 6.1372,-19.165 6.6831,-38.586 5.5288,-58.234 -0.3272,-5.5676 -1.9866,-11.15 -3.6634,-16.53 -12.668,-40.645 -35.506,-73.794 -73.067,-95.068 -20.776,-11.767 -43.23804,-19.067 -67.63704,-18.47 -6.9962,0.1711 -14,0 -20.998,0.1445 -42.171,0.8845 -76.744,18.022 -103.51,50.169 -19.643,23.589 -31.219,51.352 -40.37,80.61 -4.2484,13.583 0.57764,24.878 2.9208,36.766 5.6691,28.763 12.995,57.382 13.333,86.75 0.44922,39.092 -9.132,75.962 -32.653,107.91 -16.903,22.96 -39.52,38.516 -67.388,45.571 -12.244,3.0996 -24.629,6.1521 -37.138,7.5947 -31.846,3.6731 -62.622,-1.3488 -91.104,-16.133 -20.604,-10.696 -37.695,-25.777 -50.728,-45.55 -13.32,-20.208 -25.284,-40.806 -29.572,-64.987 -1.1009,-6.208 -1.9313,-12.496 -2.3723,-18.783 -0.98748,-14.078 -2.5179,-27.988 -0.72497,-42.332 1.9017,-15.214 3.5549,-30.405 7.7014,-45.146 10.76,-38.252 7.5201,-75.019 -14.392,-108.34 -22.621,-34.394 -52.774,-59.833 -94.449,-68.72 -14.368,-3.064 -28.334,-1.3931 -42.387,2.571 -26.476,7.469 -50.214,19.465 -69.514,39.448 -16.008,16.575 -25.449,36.875 -29.926,58.913 -2.6767,13.175 -1.2528,27.191 -1.59,40.832 -0.60446,24.451 3.8333,48.418 6.6274,72.571 1.8686,16.153 3.5648,32.858 1.5151,48.825 -4.4961,35.023 -16.525,67.203 -44.527,91.161 -17.221,14.735 -36.72,23.885 -59.69,24.678 -0.9993,0.034 -2.0061,-0.01 -2.9975,0.095 -38.278,4.0488 -68.102996,-11.925 -92.292996,-39.942 -19.954,-23.111 -36.357,-48.399 -44.681,-78.352 -8.0839,-29.088 -9.2654,-58.728 -5.6381,-88.254 3.782,-30.785 13.497,-60.331 24.16,-89.449 0.6804,-1.8579 1.2775,-3.7463 2.1749,-6.3916 -2.288,-0.7751 -4.2888,-1.6657 -6.3842,-2.1267 -9.4221,-2.0735 -18.855,-4.1074 -28.316,-5.9887 -5.7499,-1.1434 -8.4517,-4.6372 -9.1392,-10.277 -0.92516,-7.5893 -2.98520004,-15.145 -3.01820004,-22.722 -0.24085,-55.327 -1.344,-110.7 0.38906,-165.97 1.06380004,-33.927 3.32760004,-67.827 3.25820004,-101.81 -0.02036,-9.968 0.29348,-10.264 10.033,-13.12 6.3513,-1.863 12.96,-3.5761 19.52,-3.8701 26.313,-1.1792 47.409,-13.122 64.404,-32.053 15.830996,-17.634 24.494996,-39.178 30.778996,-62.032 5.646,-20.534 1.9818,-41.062 2.8186,-61.571 0.0802,-1.9666 -0.17616,-4.058 -0.78616,-5.9248 -9.8319,-30.085 -24.988,-56.767 -50.840996,-75.991 -6.8645,-5.1046 -15.135,-8.3479 -22.845,-12.279 -12.486,-6.3664 -15.192,-13.466 -11.08,-26.678 2.5539,-8.2062 3.8405,-16.798 5.931,-25.159 5.564,-22.252 11.094,-44.514 16.928,-66.695 14.498,-55.118 33.391996,-108.85 51.977996,-162.66 7.7119,-22.326 16.885,-44.157 25.685,-66.097 23.961,-59.739 51.539,-117.83 81.642,-174.67 32.136,-60.67905 66.878,-119.88005 106.4,-176.11005 23.166,-32.957 46.648,-65.702 70.551,-98.127 11.843,-16.066 24.951,-31.2 37.502,-46.744 20.495,-25.382 40.935,-50.809 61.536,-76.105 9.0307,-11.089 18.297,-21.991 27.651,-32.809 7.118,-8.2316 15.903,-10.357 26.127,-6.263 8.3514,3.3441 16.676,6.7817 25.154,9.7778 12.551,4.4354 25.07,9.1134 37.917,12.49 6.1994,1.6296 13.433,1.8917 19.66,0.44794 53.758,-12.466 86.637,-47.195 102.59,-98.84 3.2816,-10.621 7.3831,-21.78 4.6874,-33.246 -3.9071,-16.619 -3.1136,-34.666 -14.577,-49.12 -2.0168,-2.5432 -3.2628,-5.8289 -4.3563,-8.9498 -4.2039,-11.998 -2.8654,-18.591 7.1456,-26.314 17.406,-13.427 35.278,-26.253 53.041,-39.212 27.191,-19.838 54.42,-39.625 81.697,-59.344 51.637,-37.329 104.97,-72.025 161.19001,-102.09 33.484,-17.907 66.842,-36.249 101.36,-51.981 43.615,-19.88 87.972,-38.28 132.69,-55.567 73.753,-28.513997 149.79,-49.797997 226.54,-68.658997 51.493,-12.653 103.39,-23.248 155.72,-31.539 28.275,-4.4794 56.854,-7.0239 85.278,-10.593 34.061,-4.2769003 68.364,-5.5379003 102.51,-8.4303003 63.302,-5.3618 126.57,-2.38009999 189.84,-2.34669999 29.882,0.0158 59.769,3.97299999 89.638,6.33909999 18.925,1.4992 37.859,3.0144003 56.72,5.1389003 25.154,2.8333 50.303,5.8437 75.345,9.5228 62.691,9.2104 124.77,21.624 185.93,38.208 34.069,9.2382 67.918,19.367 101.58,29.997 57.543,18.168997 113.72,39.963997 168.88,64.492997 72.574,32.269 142.95,68.755 210.8,109.92 62.403,37.86 123.26,78.153 181.06,122.89 12.645,9.7874 25.644,19.136 37.991,29.281 10.572,8.6866 13.208,23.345 7.2397,35.853 -1.8564,3.8906 -4.2527,7.5387 -6.5669,11.193 -8.1111,12.808 -14.286,26.301 -15.459,41.693 -0.1477,1.9385 -0.7647,3.9613 -1.6453,5.7016 -2.7532,5.4399 -2.3464,10.784 -0.6943,16.481 3.518,12.132 5.3579,24.909 10.153,36.481 12.938,31.223 32.452,57.502 63.204,73.398 24.456,12.642 50.162,15.963 76.254,5.1785 16.907,-6.988 33.548,-14.697 49.921,-22.859 7.0872,-3.5331 13.195,-4.0201 19.521,0.50012 5.1269,3.6631 10.815,6.9246 14.944,11.537 26.207,29.279 53.122,58.021 77.742,88.6 31.324,38.905 61.23,78.99 90.772,119.28 40.252,54.899 75.037,113.35 108.41,172.60009 17.812,31.626 35.273,63.508 51.366,96.03 16.245,32.829 31.014,66.412 45.703,99.983 31.954,73.031 59.52,147.76 82.644,224.01 9.6472,31.812 15.914,64.654 23.576,97.06 2.2984,9.7204 3.7293,19.656 6.2578,29.309 3.574,13.644 -2.1516,24.699 -15.831,29.386 -11.328,3.8814 -22.819,7.3824 -33.889,11.906 -31.823,13.003 -50.789,37.152 -60.575,69.71 -5.8232,19.375 -4.3935,38.998 -3.5647,58.48 0.427,10.032 3.9715,20.351 8,29.727 10.405,24.219 25.023,45.472 47.3,60.634 12.995,8.8441 26.929,14.349 42.944,14.05 12.661,-0.2366 25.331,0.049 37.997,0.097 3.2775,0.012 6.5551,0 11.205,0 1.2725,16.424 3.2024,31.919 3.5207,47.447 0.6216,30.321 0.3401,60.661 0.4363,90.993 0.1724,54.33 0.3428,108.66 0.5249,162.99 0.034,10.065 -0.2522,11.045 -10.162,14.356 -8.8128,2.9453 -17.941,4.9414 -26.916,7.4109 -1.8594,0.5117 -3.6526,1.2644 -6.3276,2.2056 2.7251,9.8562 5.5229,19.31 7.9387,28.86 4.1662,16.469 8.6289,32.891 11.994,49.529 4.5574,22.54 7.6707,45.329 7.3111,68.422 -0.056,3.5884 -1.0291,7.1746 -1.7041,10.738 -0.555,2.928 -1.585,5.7888 -1.9124,8.7339 -5.0037,45.016 -24.119,82.78 -58.723,112.11 -26.212,22.214 -57.209,30.469 -91.18,28.38 -28.65,-1.7612 -53.605,-12.39 -74.707,-31.826 -14.568,-13.417 -27.37,-28.31 -35.526,-46.58 -2.8318,-6.3437 -5.462,-13.04 -6.5808,-19.839 -4.2793,-25.999 -7.7217,-52.226 -4.6924,-78.559 1.7478,-15.192 3.8437,-30.294 3.9524,-45.608 0.01,-0.9834 0.049,-2.1469 0.5493,-2.9184 5.7908,-8.9263 2.3454,-17.665 0.4831,-26.9 -2.3684,-11.745 -4.1716,-23.519 -8.2802,-34.883 -4.5638,-12.623 -10.341,-24.443 -18.229,-35.377 -24.485,-33.94 -57.815,-53.602 -98.535,-60.906 -18.532,-3.324 -37.163,-2.4195 -56.094,3.5967 m -1693.6,-485.94 c -13.776,-17.644 -28.195,-35.129 -46.886,-47.391 -44.278,-29.048 -92.858,-34.98 -143.53,-21.092 -36.893,10.112 -66.141,32.476 -89.629,62.133 -12.384,15.637 -23.908,32.172 -29.05,51.968 -3.6693,14.128 -8.0391,28.244 -9.8175,42.647 -1.9113,15.479 -0.051,31.12 2.402,46.72 7.311,46.5 30.171,83.291 67.08,111.89 21.85,16.93 46.878,26.415 73.73,31.407 33.012,6.1371 65.593,5.3609 97.162,-7.5918 24.03,-9.8597 45.735,-23.194 62.854,-43.07 16.851,-19.566 29.676,-41.617 40.604,-64.998 12.416,-26.565 16.507,-54.355 11.086,-82.709 -5.4866,-28.698 -17.939,-54.968 -36.003,-79.913 m 633.34,-25.345 c -11.194,-10.403 -21.448,-22.129 -33.798,-30.906 -19.629,-13.95 -41.456,-23.799 -65.66,-27.83 -27.633,-4.6025 -54.954,-5.1484 -81.866,3.805 -38.001,12.642 -69.965,33.73 -93.182,66.981 -9.1865,13.157 -17.363,26.821 -22.281,42.235 -3.5325,11.071 -7.0772,21.971 -8.3779,33.767 -0.8929,8.0954 -4.2293,16.047 -3.5193,24.467 0.9768,11.586 1.3999,23.308 3.5495,34.691 8.4429,44.706 27.818,83.354 65.519,110.63 42.066,30.434 88.646,43.692 140.5,33.843 39.216,-7.4474 72.252,-25.281 98.05,-56.659 22.176,-26.973 38.399,-56.559 46.89,-90.438 4.3821,-17.486 4.2422,-35.311 0.5667,-52.454 -7.2945,-34.023 -21.984,-64.864 -46.394,-92.132 m 626.93,149.01 c 3.0422,-8.8348 5.7998,-17.688 5.6726,-27.233 -0.043,-3.2563 1.3096,-6.5061 1.6221,-9.797 0.7177,-7.5624 2.1499,-15.23 1.5183,-22.704 -0.8071,-9.5443 -2.6507,-19.144 -5.2781,-28.368 -16.125,-56.607 -50.119,-97.777 -105.51,-119.76 -16.447,-6.528 -33.578,-11.21 -51.499,-10.567 -7.56,0.2708 -15.028,2.5666 -22.585,3.5836 -23.861,3.2109 -45.909,11.538 -65.693,24.973 -29.319,19.909 -51.35,46.157 -65.353,78.957 -7.6282,17.867 -13.284,36.48 -15.751,55.541 -2.3376,18.068 -1.5769,36.441 2.4683,54.646 14.194,63.878 51.662,106.01 114.83,124.38 16.353,4.7542 33.145,8.2961 50.297,5.5182 40.627,-6.5801 77.121,-20.748 106.85,-51.437 21.666,-22.365 37.558,-47.288 48.408,-77.728 m -2173.50001,49.453 c 8.4252,23.364 23.362,42.138 40.207,60.072 25.257,26.892 94.968,52.369 131.7,41.226 47.89301,-5.095 82.00901,-32.405 110.25001,-68.841 12.55,-16.192 20.793,-34.882 28.26,-53.781 6.1429,-15.549 9.8141,-31.74 8.5805,-48.729 -0.4094,-5.6382 -0.6203,-11.35 -0.212,-16.977 1.239,-17.078 -3.2068,-33.099 -9.1483,-48.701 -18.581,-48.793 -53.745,-80.815 -102.05,-98.914 -15.26401,-5.7192 -31.09601,-10.087 -47.63801,-9.2682 -7.5662,0.3745 -15.168,1.8994 -22.549,3.7295 -13.19,3.2704 -26.519,6.3577 -39.261,10.98 -23.025,8.3526 -41.256,23.782 -58.104,41.252 -28.134,29.173 -43.424,64.833 -49.263,103.87 -4.1312,27.621 -2.2083,55.92 9.2272,84.084 m 943.12001,-737.22 c 0.8907,-11.622 -2.9556,-22.397 -6.298,-33.172 -15.369,-49.54309 -45.715,-85.95009 -94.371,-105.71009 -11.055,-4.4893 -22.475,-9.4414 -34.124,-10.81 -21.086,-2.4781 -42.425,-3.0823 -63.482,2.3817 -60.45,15.685 -100.49,53.768 -122.49,111.44 -4.2371,11.10909 -5.8045,23.21609 -9.7278,34.47009 -3.5652,10.227 -3.264,20.247 -1.5601,30.512 0.8724,5.2535 1.7856,10.518 3.0634,15.683 4.1748,16.872 9.7742,33.071 19.414,47.87 10.29,15.798 23.234,29.06 36.504,42.198 27.278,27.007 60.017,39.714 98.319,38.937 28.551,-0.579 55.282,-8.0593 80.504,-20.893 18.481,-9.4034 35.664,-20.743 48.94,-37.24 12.182,-15.137 22.881,-31.131 30.104,-49.23 8.2804,-20.748 14.824,-41.946 15.204,-66.443 m 639.86,9.3819 c -0.09,-11.327 -0.066,-22.657 -0.3279,-33.98 -0.1,-4.3062 -0.3205,-8.7379 -1.4016,-12.87309 -10.052,-38.445 -27.938,-71.82 -61.885,-94.705 -28.128,-18.962 -57.862,-32.948 -92.972,-30.969 -7.6467,0.43085 -15.326,0.27448 -22.975,0.67243 -3.9714,0.20654 -8.0344,0.58837 -11.846,1.6475 -54.604,15.175 -96.202,46.477 -119.65,98.992 -7.2231,16.178 -15.763,32.50206 -13.473,51.46406 0.2502,2.0729 -0.9756,4.5591 -2.103,6.5155 -2.5152,4.3648 -2.5335,8.7726 -1.4764,13.511 1.2269,5.4999 2.0787,11.083 3.105,16.628 3.5376,19.112 9.0784,37.39 19.568,54.106 11.856,18.892 27.063,34.647 44.013,48.74 21.265,17.681 46.129,28.531 73.366,31.729 55.289,6.4904 101.38,-14.902 140.41,-52.011 19.647,-18.681 33.982,-41.949 41.767,-68.4 2.7922,-9.4862 3.9687,-19.448 5.8825,-31.066 m 1127.8,565.12 c -4.2839,-5.5235 -8.2119,-11.372 -12.913,-16.514 -20.625,-22.559 -46.599,-35.516 -75.676,-44.282 -20.998,-6.3305 -40.675,-4.1204 -60.631,2.0982 -33.852,10.549 -57.881,33.041 -75.929,62.837 -8.2486,13.618 -11.603,28.912 -16.353,43.793 -4.8999,15.352 -7.5964,30.756 -7.7375,46.989 -0.4007,46.114 20.013,83.126 50.914,114.67 15.803,16.13 35.712,27.98 56.959,36.438 13.915,5.5398 28.45,10.57 43.697,8.5303 16.199,-2.1669 31.754,-6.947 46.402,-14.768 16.445,-8.7806 29.763,-21.024 42.649,-34.205 9.6824,-9.9036 17.381,-20.841 24.012,-32.93 16.587,-30.236 20.314,-62.82 15.404,-95.934 -4.0171,-27.089 -13.687,-52.859 -30.798,-76.721 m -2383.8,-609.98006 c -1.3361,-3.4131 -2.6535,-6.8337 -4.0117,-10.238 -7.8838,-19.76 -20.618,-35.839 -38.109,-47.743 -30.867,-21.008 -65.676,-25.843 -101.49001,-20.177 -35.457,5.6098 -66.017,21.775 -90.247,49.282 -25.754,29.237 -40.757,62.64606 -42.773,101.71006 -0.10034,1.9455 -0.5127,4.1166 -1.5098,5.732 -4.1869,6.7835 -3.6049,14.066 -2.5311,21.362 0.92114,6.2585 2.3525,12.44 3.3874,18.684 4.6441,28.021 17.341,51.527 38.919,70.172 20.362,17.594 43.638,27.212 70.782,28.6 26.846,1.3724 51.51201,-5.3336 75.17701,-16.951 20.226,-9.9284 38.33,-23.059 53.523,-39.638 13.812,-15.072 24.489,-32.432 32.018,-51.535 8.4535,-21.448 14.659,-43.338 15.131,-66.733 0.2908,-14.407 -4.1864,-27.548 -8.2671,-42.52806 m 1867.8,42.02406 c 0.7336,-18.029 -0.4773,-35.762 -4.5533,-53.51506 -12.445,-54.206 -53.629,-87.812 -108.12,-91.811 -9.9384,-0.72918 -19.981,0.0565 -29.971,-0.0966 -11.878,-0.18194 -23.161,2.6692 -34.02,6.9634 -51.526,20.378 -85.132,57.679 -103.3,109.64006 -3.2275,9.231 -3.1614,19.121 -6.0093,28.081 -3.709,11.668 -3.2864,22.903 -1.9165,34.47 0.7044,5.9465 1.7576,11.863 2.908,17.744 4.9167,25.134 15.788,47.552 33.46,65.944 30.137,31.366 68.048,39.289 109.32,31.616 43.335,-8.057 76.01,-33.858 103.48,-67.027 10.027,-12.106 19.064,-24.975 24.727,-39.702 5.118,-13.311 9.1675,-27.032 13.999,-42.302 m -2696.40001,586.27 c -9.7495,19.613 -20.876,38.775 -20.098,61.821 0.0321,0.9522 -0.26532,2.0556 -0.7689,2.8646 -5.3561,8.6052 -4.164,18.025 -3.0723,27.252 2.5964,21.945 7.9536,43.224 16.374,63.703 15.429,37.521 42.112,62.347 81.483,73.503 11.14,3.1565 22.215,4.7786 33.536,3.1269 14.239,-2.0773 27.77,-6.5257 40.743,-13.018 26.32,-13.172 46.988,-32.556 63.481,-56.579 11.205,-16.322 19.731,-34.057 24.635,-53.272 3.1158,-12.208 5.7794,-24.606 7.4395,-37.079 0.8952,-6.7261 -0.59912,-13.806 -1.3169,-20.694 -0.30621,-2.9386 -2.0781,-5.8186 -1.9879,-8.6877 0.37744,-11.999 -3.5366,-22.978 -7.5571,-33.91 -9.5768,-26.04 -22.979,-49.058 -46.403,-65.772 -40.642,-29 -82.826,-30.112 -126.25,-8.4982 -27.541,13.707 -46.32,36.435 -60.233,65.24 M 2883.5021,556.52354 c -3.3836,-12.51 -6.0291,-25.278 -10.302,-37.476 -9.2251,-26.336 -24.814,-48.057 -47.286,-65.242 -22.606,-17.287 -46.922,-30.266 -74.866,-36.017 -4.5,-0.92605 -9.3972,-2.07 -13.743,-1.2235 -17.655,3.4391 -34.647,8.7003 -50.375,18.052 -15.287,9.0899 -26.351,21.849 -32.948,37.706 -13.342,32.075 -15.24,65.225 -4.7361,98.598 7.9163,25.15 20.428,47.337 40.309,65.51 17.344,15.854 34.76,31.257 57.235,39.149 10.898,3.8267 22.258,6.7902 33.654,8.6171 10.825,1.7354 21.027,-3.1309 30.861,-7.0025 30.222,-11.898 52.579,-32.095 63.638,-63.345 1.9883,-5.6185 3.0515,-11.562 4.593,-17.341 3.3467,-12.545 6.685,-25.086 3.9661,-39.985 m 431.3,400.11 c -2.9797,-0.11523 -6.0781,-0.81995 -8.9201,-0.24963 -17.977,3.6073 -35.668,8.1915 -50.889,19.087 -5.9182,4.2366 -12.522,8.1519 -16.977,13.69 -24.912,30.96609 -32.043,66.48409 -24.968,105.15009 3.7613,20.554 11.917,39.543 22.779,57.214 8.5398,13.892 18.688,26.476 31.738,36.849 19.784,15.726 42.099,25.616 66.49,30.624 21.493,4.4131 42.694,2.0488 61.8,-9.4024 25.084,-15.034 43.32,-36.117 52.702,-64.213 1.5694,-4.7 3.5987,-9.5373 3.7593,-14.366 0.6873,-20.656 -0.32,-40.98 -7.104,-61.049 -12.538,-37.092 -34.926,-65.991 -67.333,-87.62509 -18.847,-12.582 -39.48,-20.479 -63.077,-25.706 m -1641.4,-304.29 c 42.747,-6.0214 76.078,-26.95 99.564,-63.223 9.7082,-14.994 16.586,-31.56 19.086,-49.018 2.8143,-19.654 -0.476,-39.139 -8.8893,-57.529 -7.0006,-15.302 -15.556,-29.705 -28.128,-40.835 -13.538,-11.985 -29.599,-20.421 -46.474,-26.895 -15.417,-5.915 -31.486,-9.1463 -47.991,-6.0706 -33.6,6.2617 -61.596,22.289 -83.772,48.602 -16.91,20.065 -26.914,43.621 -28.967,68.957 -3.2922,40.642 12.929,74.418 45.766,98.724 22.862,16.923 49.028,26.634 79.805,27.288 m 598.53,-158.3 c -1.0332,-4.1729 -1.5325,-8.5724 -3.1912,-12.48 -7.6115,-17.934 -17.777,-34.071 -32.006,-47.771 -33.6,-32.349 -72.502,-42.277 -116.67,-27.366 -37.104,12.526 -64.765,36.638 -79.948,73.207 -5.552,13.373 -9.0881,27.707 -12.213,41.896 -1.1136,5.0557 1.6118,10.999 2.75,16.502 7.5251,36.386 24.165,66.659 57.082,86.392 25.669,15.387 52.282,24.139 82.596,16.131 25.032,-6.6126 47.794,-17.74 65.822,-36.073 24.436,-24.85 39.134,-54.422 36.115,-90.674 -0.4964,-5.9602 -0.2105,-11.986 -0.3355,-19.764 m -1720.00001,481.61 c -9.4321,-5.3687 -20.108,-6.6138 -30.31,-9.5198 -6.4854,-1.847 -12.255,-2.1917 -18.437,0.1189 -2.4709,0.9234 -5.1111,1.5685 -7.7298,1.8926 -15.225,1.8849 -28.92,7.8249 -41.469,16.267 -24.756,16.65409 -44.665,37.91509 -58.16,64.65009 -7.3566,14.574 -14.053,29.994 -15.599,46.104 -2.0563,21.431 -3.2702,43.324 3.1263,64.525 5.2898,17.534 13.17,34.187 28.116,45.067 28.887,21.028 60.055,26.944 93.973,10.97 31.52,-14.845 55.01,-38.228 74.182,-66.485 13.612,-20.062 23.833,-41.571 24.873,-66.448 0.0811,-1.9381 0.61255,-4.0529 1.569,-5.7219 2.7658,-4.8264 2.7277,-9.3577 -0.11212,-14.15 -0.9729,-1.6416 -1.4682,-3.8229 -1.4536,-5.7521 0.11279,-14.884 -6.0919,-27.89 -12.319,-40.772 -8.4969,-17.57509 -21.047,-31.48009 -40.249,-40.74609 m 643.08003,-565.05 c -30.372,-21.494 -63.68,-23.524 -98.278,-13.897 -37.424,10.413 -66.458,32.687 -88.461,64.583 -11.04003,16.003 -15.03703,34.589 -21.16603,52.504 -5.3572,15.659 -4.6013,30.751 0.1884,46.025 6.4644,20.615 18.49403,36.795 38.40003,46.226 29.784,14.111 60.656,14.432 91.56,5.1626 36.412,-10.922 65.586,-32.844 86.32,-64.466 14.745,-22.488 27.227,-46.059 25.22,-75.152 -1.7751,-25.725 -13.881,-44.376 -33.781,-60.985 m 717.27,-211.05 c 2.5076,0.88985 4.995,1.8422 7.5259,2.6596 21.377,6.9049 41.213,4.0892 59.755,-8.8699 9.9515,-6.9551 16.275,-16.752 21.537,-27.054 12.818,-25.094 16.303,-24.676 4.5068,-55.229 -10.979,-28.435997 -34.018,-45.049997 -64.533,-46.845997 -4.932,-0.29037 -10.178,-0.47674 -14.845,0.83335 -22.995,6.455 -39.718,21.339 -51.261,41.652997 -4.1308,7.2691 -5.451,16.225 -7.47,24.553 -0.6593,2.7193 0.3414,5.9245 0.9221,8.8398 0.7136,3.5816 1.7844,7.092 2.6973,10.634 5.7383,22.269 18.537,38.72 41.165,48.826 z",
    fill: "#000aff",
    id: "path1208"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 1851.6351,3031.341 c -52.812,-21.87 -88.613,-59.458 -108.96,-111.7 -11.097,-28.491 -14.301,-58.605 -9.9092,-88.54 5.1745,-35.272 18.197,-67.605 41.532,-95.826 25.766,-31.161 58.736,-49.357 96.779,-59.721 8.2481,-2.2468 17.098,-2.8115 25.705,-3.0942 13.979,-0.459 28.012,-0.5632 41.976,0.1196 21.925,1.0728 42.929,7.0244 62.251,17.016 47.707,24.67 83.075,60.892 99.852,112.97 3.4343,10.66 4.6423,22.065 6.5552,33.182 3.133,18.21 0.8918,36.546 -0.2246,54.699 -0.7017,11.406 -4.075,23.01 -8.2095,33.772 -10.128,26.36 -23.918,50.553 -46.09,69.058 -25.798,21.531 -54.883,36.349 -87.905,42.889 -15.319,3.0335 -30.743,6.0713 -46.264,7.3494 -9.7287,0.801 -19.857,-0.9861 -29.571,-2.8413 -12.39,-2.3665 -24.542,-5.9739 -37.52,-9.3386 z",
    fill: "#000aff",
    id: "path1209"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 2594.4351,2670.241 c 22.571,3.946 43.582,9.538 63.726,19.089 42.7,20.245 68.386,53.887 80.792,98.607 5.3621,19.329 8.5327,39.011 8.2837,59.157 -0.078,6.3267 0.2954,12.664 0.077,18.983 -1.9971,57.898 -24.924,104.53 -73.583,137.61 -27.913,18.972 -58.849,29.119 -92.004,33.418 -8.2302,1.0669 -16.557,3.6418 -24.649,3.0236 -14.18,-1.0842 -28.586,-2.7639 -42.232,-6.5771 -31.834,-8.8965 -61.55,-22.708 -83.373,-48.523 -21.003,-24.846 -37.01,-52.838 -45.127,-84.729 -1.3809,-5.4246 -1.8523,-11.175 -2.0139,-16.797 -0.4121,-14.313 -0.3172,-28.64 -0.5933,-42.958 -0.6626,-34.346 11.855,-64.226 30.582,-92.18 12.97,-19.361 29.4,-35.102 48.089,-48.805 26.934,-19.748 57.49,-29.085 90.333,-30.992 13.537,-0.7859 27.219,0.9389 41.693,1.677 z",
    fill: "#000aff",
    id: "path1210"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 1414.4351,2728.341 c 28.146,28.296 43.049,62.326 47.788,100.71 1.9071,15.446 0.3075,31.292 1.2368,46.9 1.5316,25.722 -5.8755,49.417 -15.963,72.349 -6.9038,15.695 -17.895,28.571 -31.4,39.471 -13.799,11.138 -28.244,21.044 -44.09,29.032 -19.077,9.6179 -39.438,13.879 -60.512,15.376 -6.9702,0.4951 -13.982,0.3725 -20.971,0.6455 -35.848,1.3989 -68.352,-8.9092 -98.166,-28.291 -37.042,-24.08 -62.934,-57.354 -77.225,-98.852 -6.0142,-17.464 -8.619,-36.228 -11.423,-54.607 -1.1008,-7.2158 1.4385,-15.003 2.4396,-22.514 0.3047,-2.2864 1.2289,-4.4939 1.4967,-6.7812 3.699,-31.587 13.614,-60.777 32.183,-86.937 28.812,-40.591 67.814,-61.66 117.62,-62.546 8.6572,-0.1538 17.325,0.1795 25.979,-0.047 51.996,-1.3618 95.771,16.493 131.01,56.095 z",
    fill: "#000aff",
    id: "path1211"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m 3300.2351,2903.141 c -7.9861,16.199 -15.155,31.917 -25.586,45.973 -23.071,31.09 -53.005,52.388 -91.314,57.704 -40.207,5.5791 -80.404,4.8679 -117.82,-15.635 -31.37,-17.192 -52.604,-42.456 -64.018,-76.054 -8.7939,-25.887 -11.772,-52.637 -9.3523,-79.838 0.8201,-9.2197 2.968,-18.354 4.9541,-27.43 4.0762,-18.628 10.766,-36.273 19.906,-53.072 27.792,-51.083 91.817,-92.871 156.72,-86.44 37.719,3.7373 72.457,15.806 100.43,42.313 17.394,16.482 28.924,37.102 36.623,59.982 7.018,20.859 9.9812,42.138 8.5988,63.939 -0.562,8.8674 -2.2888,17.832 -4.7973,26.366 -4.1153,14.001 -9.3015,27.687 -14.354,42.192 z",
    fill: "#000aff",
    id: "path1212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 641.22506,2677.941 c 40.937,-15.713 80.482,-12.739 119.14,4.8601 25.022,11.394 47.962,26.109 66.97,46.361 22.017,23.458 34.801,51.751 42.921,82.404 1.1713,4.4222 0.99097,9.2622 1.0324,13.913 0.14844,16.66 1.0428,33.386 -0.13739,49.96 -0.88739,12.464 -3.3358,25.122 -7.2426,36.985 -4.547,13.806 -10.127,27.631 -17.596,40.04 -14.543,24.164 -37.764,37.939 -63.563,47.581 -26.881,10.045 -54.953,10.356 -82.883,7.7004 -12.005,-1.1413 -24.376,-4.9389 -35.259,-10.243 -48.054,-23.424 -83.08,-59.428 -101.55,-110.26 -9.2081,-25.34 -13.554,-51.585 -11.045,-78.531 1.0091,-10.839 3.7778,-21.549 6.2361,-32.205 1.6359,-7.091 3.8646,-14.079 6.3006,-20.946 13.315,-37.532 39.843,-62.172 76.683,-77.619 z",
    fill: "#000aff",
    id: "path1213"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m 2028.8351,3497.941 c -17.744,10.412 -35.947,17.965 -55.603,20.559 -35.442,4.677 -70.425,3.3191 -103.79,-11.622 -17.081,-7.6484 -33.414,-16.534 -47.988,-28.398 -2.0614,-1.6783 -4.22,-3.3023 -5.9928,-5.2601 -23.587,-26.051 -39.806,-55.677 -43.938,-91.119 -0.077,-0.6609 0.047,-1.3816 -0.1711,-1.9851 -7.354,-20.368 0.7025,-39.578 3.9783,-59.281 4.4577,-26.813 18.214,-49.145 35.932,-67.912 22.313,-23.634 49.142,-41.98 82.54,-47.648 7.2208,-1.2254 14.392,-2.8608 21.656,-3.6953 31.682,-3.6394 61.512,3.7307 90.354,16.037 16.368,6.9839 31.271,16.75 44.275,28.689 18.393,16.886 31.522,37.736 40.459,61.084 6.0027,15.683 9.4697,31.872 8.9152,48.804 -0.2177,6.6539 -0.3137,13.345 0.1211,19.981 1.5879,24.221 -7.0593,45.833 -17.637,66.646 -11.878,23.371 -29.516,41.74 -53.109,55.121 z",
    fill: "#000aff",
    id: "path1214"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m 2496.5351,3516.141 c -20.186,-3.5969 -39.478,-7.2495 -57.524,-15.484 -16.753,-7.6451 -32.982,-16.496 -45.662,-29.914 -15.042,-15.918 -26.178,-34.629 -30.411,-56.439 -3.2217,-16.6 -7.7346,-33.602 -6.9236,-50.194 1.6053,-32.853 11.359,-63.662 30.021,-91.638 22.286,-33.408 55.244,-51.046 90.948,-65.121 6.4243,-2.5325 13.499,-3.7661 20.395,-4.6892 25.502,-3.4143 51.054,-4.9385 76.396,1.2205 5.4612,1.3271 11.103,2.9265 15.92,5.6921 14.12,8.1045 28.676,15.793 41.583,25.592 23.647,17.953 37.604,42.539 44.546,71.382 4.1934,17.42 4.1067,35.063 3.5215,52.653 -0.3047,9.1561 -2.7937,18.347 -5.1477,27.298 -2.5249,9.6008 -6.2683,18.874 -9.085,28.407 -3.9702,13.436 -11.693,24.541 -20.762,34.887 -19.592,22.352 -42.205,40.807 -70.263,51.315 -13.312,4.9859 -27.258,8.5125 -41.158,11.616 -11.608,2.592 -23.37,5.7141 -36.395,3.4165 z",
    fill: "#000aff",
    id: "path1215"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m 1496.7351,3286.041 c 12.781,22.982 18.541,47.003 18.552,72.487 0,6.3315 0.063,12.663 0.1,18.995 0.1963,33.441 -9.2877,63.617 -30.681,89.617 -12.379,15.044 -28.653,25.051 -46.429,31.972 -25.65,9.9861 -52.493,16.221 -80.123,12.859 -39.548,-4.8133 -75.39,-18.5 -104.15,-47.767 -16.461,-16.748 -31.933,-33.955 -41.583,-55.702 -6.2485,-14.081 -11.188,-28.493 -12.972,-43.886 -0.4197,-3.6204 -1.3119,-7.1941 -2.1162,-10.76 -2.6826,-11.893 -3.4919,-23.687 1.2109,-35.347 0.7301,-1.8103 0.98,-3.8889 1.0899,-5.8635 1.2606,-22.668 11.703,-41.636 25.385,-58.64 18.174,-22.584 41.286,-38.622 69.639,-46.178 6.3937,-1.7041 13.06,-3.1465 19.631,-3.2837 20.294,-0.4233 40.494,0.2773 60.82,2.1841 41.67,3.9084 74.1,24.349 102.34,53.05 7.3752,7.4954 12.688,17.02 19.29,26.264 z",
    fill: "#000aff",
    id: "path1216"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m 2933.8351,3406.641 c -2.2893,-10.104 -4.3665,-19.484 -6.178,-28.915 -1.3609,-7.0852 -4.5916,-14.804 -2.9488,-21.203 1.7559,-6.8374 2.065,-13.668 3.4952,-20.376 2.2815,-10.698 5.0214,-21.432 8.9467,-31.619 9.0498,-23.487 20.881,-45.602 39.785,-62.72 18.912,-17.124 39.901,-31.27 65.256,-37.307 11.659,-2.7754 23.385,-5.4854 35.228,-7.2293 25.335,-3.7309 49.993,0.9512 73.6,9.5025 15.485,5.6084 27.802,16.609 37.802,30.111 15.672,21.163 23.402,44.636 22.601,70.95 -0.1216,3.9951 -0.3777,8.052 0.1353,11.988 1.5634,11.996 -2.1853,23.222 -5.491,34.25 -8.0767,26.945 -21.928,51.047 -42.297,70.372 -38.683,36.701 -84.146,57.479 -138.63,51.661 -39.651,-4.2349 -68.819,-24.998 -87.099,-60.651 -1.3672,-2.6673 -2.5928,-5.4068 -4.2102,-8.8142 z",
    fill: "#000aff",
    id: "path1217"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m 805.78506,3196.541 c 34.432,5.6788 64.976,18.04 91.081,40.241 23.922,20.344 40.843,45.431 50.252,75.466 6.1234,19.547 10.107,39.627 8.3123,60.038 -2.3603,26.846 -8.4124,52.825 -29.637,72.015 -18.785,16.984 -40.107,28.476 -66.371,28.168 -8.3283,-0.098 -16.667,0 -24.99,0.303 -21.14,0.7624 -40.744,-4.9502 -59.935,-13.224 -33.541,-14.459 -59.73,-37.364 -78.632,-68.377 -14.195,-23.291 -24.429,-48.095 -24.093,-76.117 0.04,-3.3308 0.0531,-6.6738 -0.17456,-9.9941 -3.1867,-46.482 31.385,-90.215 76.941,-103.23 18.575,-5.3069 37.25,-6.9273 57.246,-5.2896 z",
    fill: "#000aff",
    id: "path1218"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m 3577.4351,2873.341 c -20.472,-15.98 -32.238,-35.945 -33.42,-61.528 -0.3378,-7.3108 -0.4795,-14.646 -0.3247,-21.962 0.6292,-29.748 9.0562,-57.49 27.001,-80.914 21.873,-28.551 51.242,-44.556 88.307,-45.213 17.614,-0.3123 33.48,3.0535 48.085,13.202 15.044,10.453 23.244,25.144 28.447,42.086 4.3794,14.26 3.4004,28.948 4.0542,43.558 1.6626,37.14 -13.968,67.603 -38.563,93.081 -17.084,17.698 -37.975,30.994 -63.967,34.021 -20.191,2.3516 -38.212,-2.012 -54.908,-13.108 -1.3855,-0.9209 -2.7449,-1.8801 -4.7119,-3.2236 z",
    fill: "#000aff",
    id: "path1219"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m 145.99506,2796.541 c -7.3659,-18.952 -7.7403,-38.061 -5.8232,-56.95 1.7805,-17.542 6.3033,-34.76 17.283,-49.311 12.96,-17.176 31.319,-25.816 51.873,-26.022 40.829,-0.4094 75.661,12.821 98.641,49.548 15.159,24.227 24.139,50.301 27.404,78.522 0.19114,1.6519 0.65256,3.4014 0.32074,4.9639 -2.8806,13.566 -5.036,27.37 -9.1205,40.574 -5.3038,17.145 -17.63,29.613 -31.45,40.42 -7.5185,5.8789 -16.792,8.1069 -25.99,9.646 -23.795,3.9827 -45.462,-1.6209 -65.673,-14.653 -28.483,-18.366 -45.855,-44.846 -57.465,-76.736 z",
    fill: "#000aff",
    id: "path1220"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m 2299.2351,3811.341 c -11.863,-42.222 3.4456,-77.749 36.438,-102.78 17.664,-13.399 37.842,-20.755 59.567,-24.192 2.6128,-0.4133 5.3982,-0.863 7.9421,-0.4035 16.703,3.0166 33.556,5.4638 49.192,12.717 15.131,7.02 25.966,18.196 33.566,32.943 9.8672,19.147 11.929,39.828 9.2683,60.397 -2.5821,19.962 -13.233,36.856 -28.212,50.522 -17.792,16.233 -38.296,26.953 -61.914,32.909 -28.751,7.2502 -52.855,-1.5093 -75.846,-17.453 -15.63,-10.838 -23.286,-26.934 -30.002,-44.664 z",
    fill: "#000aff",
    id: "path1221"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m 1405.6351,3716.741 c 14.534,-17.1 33.27,-24.128 53.846,-29.414 17.234,-4.428 32.794,-1.6211 48.821,3.2976 13.201,4.0512 25.609,9.8667 36.333,18.452 21.318,17.066 33.716,39.136 34.673,66.859 0.402,11.648 0.01,23.324 0.4306,34.971 0.2374,6.5381 -1.0296,12.444 -3.9892,18.247 -11.19,21.941 -28.309,35.694 -53.068,39.294 -4.2627,0.6199 -8.4035,2.0976 -12.669,2.6736 -5.5735,0.7519 -11.374,2.08 -16.799,1.278 -23.195,-3.4287 -45.526,-9.2959 -64.85,-23.804 -11.31,-8.4917 -17.743,-20.539 -25.609,-31.601 -1.341,-1.8855 -2.112,-4.1685 -3.3851,-6.1114 -12.862,-19.622 -13.452,-41.639 -10.952,-63.636 1.3194,-11.611 8.3576,-21.536 17.217,-30.504 z",
    fill: "#000aff",
    id: "path1222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m 1715.1351,1599.641 c 17.616,24.391 30.069,50.66 35.555,79.359 5.4206,28.354 1.3297,56.143 -11.086,82.709 -10.928,23.381 -23.752,45.432 -40.604,64.998 -17.119,19.876 -38.824,33.21 -62.854,43.07 -31.569,12.953 -64.15,13.729 -97.162,7.5918 -26.852,-4.9919 -51.88,-14.477 -73.73,-31.407 -36.909,-28.598 -59.769,-65.39 -67.08,-111.89 -2.4529,-15.6 -4.3133,-31.241 -2.402,-46.72 1.7784,-14.403 6.1482,-28.519 9.8175,-42.647 5.1418,-19.797 16.666,-36.332 29.05,-51.968 23.488,-29.657 52.736,-52.022 89.629,-62.133 50.675,-13.889 99.256,-7.957 143.53,21.092 18.69,12.262 33.109,29.747 47.333,47.945 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1223"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m 2348.4351,1574.341 c 23.96,26.721 38.649,57.562 45.944,91.585 3.6755,17.143 3.8154,34.968 -0.5667,52.454 -8.4909,33.879 -24.714,63.465 -46.89,90.438 -25.798,31.378 -58.834,49.212 -98.05,56.659 -51.858,9.8485 -98.438,-3.4094 -140.5,-33.843 -37.7,-27.275 -57.076,-65.924 -65.519,-110.63 -2.1496,-11.382 -2.5727,-23.105 -3.5495,-34.691 -0.71,-8.4201 2.6264,-16.372 3.5193,-24.467 1.3007,-11.797 4.8454,-22.696 8.3779,-33.767 4.9182,-15.414 13.095,-29.078 22.281,-42.235 23.217,-33.251 55.181,-54.338 93.182,-66.981 26.913,-8.9534 54.233,-8.4075 81.866,-3.805 24.203,4.0312 46.031,13.881 65.66,27.83 12.35,8.7765 22.604,20.503 34.248,31.453 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1224"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m 2974.6351,1723.541 c -10.59,29.698 -26.482,54.62 -48.148,76.985 -29.73,30.689 -66.224,44.857 -106.85,51.437 -17.152,2.7779 -33.944,-0.764 -50.297,-5.5182 -63.168,-18.364 -100.64,-60.501 -114.83,-124.38 -4.0452,-18.205 -4.8059,-36.578 -2.4683,-54.646 2.4663,-19.06 8.1226,-37.674 15.751,-55.541 14.003,-32.8 36.034,-59.048 65.353,-78.957 19.784,-13.434 41.832,-21.762 65.693,-24.973 7.5576,-1.017 15.025,-3.3128 22.585,-3.5836 17.921,-0.6422 35.052,4.0393 51.499,10.567 55.388,21.985 89.383,63.155 105.51,119.76 2.6274,9.2247 4.471,18.824 5.2781,28.368 0.6316,7.4746 -0.8006,15.142 -1.5183,22.704 -0.3125,3.2909 -1.6653,6.5407 -1.6221,9.797 0.1272,9.5449 -2.6304,18.398 -5.9316,27.976 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1225"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m 801.15506,1771.541 c -11.182,-27.424 -13.104,-55.723 -8.9733,-83.344 5.8385,-39.035 21.129,-74.695 49.263,-103.87 16.848,-17.47 35.079,-32.899 58.104,-41.252 12.742,-4.6222 26.07,-7.7095 39.261,-10.98 7.3809,-1.8301 14.983,-3.355 22.549,-3.7295 16.542,-0.8188 32.374,3.549 47.63804,9.2682 48.306,18.1 83.47,50.121 102.05,98.914 5.9415,15.603 10.387,31.623 9.1483,48.701 -0.4083,5.6269 -0.1974,11.339 0.212,16.977 1.2336,16.989 -2.4376,33.18 -8.5805,48.729 -7.4662,18.899 -15.71,37.589 -28.26,53.781 -28.24,36.435 -62.356,63.746 -110.25004,68.841 -36.732,11.143 -106.44,-14.334 -131.7,-41.226 -16.845,-17.935 -31.782,-36.709 -40.461,-60.813 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1226"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m 1744.5351,1035.941 c -0.3669,23.564 -6.9105,44.762 -15.191,65.51 -7.2235,18.099 -17.922,34.094 -30.104,49.23 -13.276,16.496 -30.459,27.836 -48.94,37.24 -25.222,12.833 -51.953,20.314 -80.504,20.893 -38.301,0.7766 -71.04,-11.93 -98.319,-38.937 -13.27,-13.138 -26.214,-26.4 -36.504,-42.198 -9.6397,-14.8 -15.239,-30.998 -19.414,-47.87 -1.2778,-5.1649 -2.191,-10.43 -3.0634,-15.683 -1.7039,-10.265 -2.0051,-20.285 1.5601,-30.512 3.9233,-11.255 5.4907,-23.361 9.7278,-34.47005 21.998,-57.676 62.04,-95.759 122.49,-111.44 21.058,-5.464 42.396,-4.8598 63.482,-2.3817 11.648,1.3689 23.068,6.3209 34.124,10.81 48.657,19.759 79.002,56.167 94.371,105.71005 3.3424,10.774 7.1887,21.55 6.285,34.105 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1227"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m 2384.4351,1045.341 c -1.9136,10.682 -3.0901,20.643 -5.8823,30.13 -7.785,26.451 -22.12,49.72 -41.767,68.4 -39.027,37.108 -85.119,58.501 -140.41,52.011 -27.237,-3.1974 -52.101,-14.048 -73.366,-31.729 -16.95,-14.093 -32.156,-29.848 -44.013,-48.74 -10.49,-16.716 -16.031,-34.993 -19.568,-54.106 -1.0263,-5.5449 -1.8781,-11.128 -3.105,-16.628 -1.0571,-4.738 -1.0388,-9.1458 1.4764,-13.511 1.1274,-1.9564 2.3532,-4.4426 2.103,-6.5155 -2.29,-18.962 6.25,-35.28505 13.473,-51.46405 23.447,-52.515 65.045,-83.818 119.65,-98.992 3.8113,-1.0591 7.8743,-1.4409 11.846,-1.6475 7.6494,-0.39795 15.328,-0.24158 22.975,-0.67243 35.111,-1.9784 64.844,12.008 92.972,30.969 33.948,22.885 51.833,56.26 61.885,94.705 1.0811,4.13508 1.3018,8.56678 1.4016,12.87308 0.2622,11.323 0.2378,22.653 0.3277,34.917 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1228"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m 3512.6351,1610.141 c 16.721,23.258 26.392,49.028 30.409,76.118 4.9106,33.114 1.1831,65.698 -15.404,95.934 -6.6313,12.088 -14.33,23.026 -24.012,32.93 -12.886,13.181 -26.204,25.424 -42.649,34.205 -14.648,7.8212 -30.203,12.601 -46.402,14.768 -15.248,2.0396 -29.782,-2.9905 -43.697,-8.5303 -21.247,-8.4588 -41.156,-20.309 -56.959,-36.438 -30.901,-31.541 -51.315,-68.553 -50.914,-114.67 0.1411,-16.233 2.8376,-31.637 7.7375,-46.989 4.75,-14.881 8.1047,-30.175 16.353,-43.793 18.048,-29.796 42.077,-52.288 75.929,-62.837 19.955,-6.2186 39.633,-8.4287 60.631,-2.0982 29.077,8.7661 55.051,21.723 75.676,44.282 4.7012,5.142 8.6292,10.991 13.302,17.117 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1229"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m 1128.6351,1000.341 c 3.8642,14.222 8.3414,27.364 8.0506,41.771 -0.472,23.395 -6.6779,45.285 -15.131,66.733 -7.5291,19.103 -18.206,36.463 -32.018,51.535 -15.193,16.579 -33.297,29.709 -53.523,39.638 -23.666,11.617 -48.33204,18.323 -75.17704,16.951 -27.144,-1.3876 -50.42,-11.005 -70.782,-28.6 -21.578,-18.645 -34.275,-42.151 -38.919,-70.172 -1.0349,-6.2441 -2.4662,-12.426 -3.3874,-18.684 -1.0739,-7.2961 -1.6558,-14.578 2.5311,-21.362 0.99713,-1.6154 1.4095,-3.7865 1.5098,-5.732 2.016,-39.066 17.019,-72.47405 42.773,-101.71005 24.23,-27.507 54.79,-43.672 90.247,-49.282 35.81304,-5.666 70.62104,-0.83166 101.49004,20.177 17.491,11.905 30.226,27.983 38.109,47.743 1.3582,3.4044 2.6756,6.825 4.2282,10.99505 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1230"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m 2996.1351,1042.441 c -4.6763,14.405 -8.7258,28.127 -13.844,41.438 -5.6628,14.727 -14.7,27.596 -24.727,39.702 -27.472,33.169 -60.147,58.97 -103.48,67.027 -41.27,7.6729 -79.18,-0.2502 -109.32,-31.616 -17.672,-18.393 -28.544,-40.81 -33.46,-65.944 -1.1504,-5.8803 -2.2036,-11.797 -2.908,-17.744 -1.3699,-11.567 -1.7925,-22.802 1.9165,-34.47 2.8479,-8.9592 2.7818,-18.85 6.0093,-28.081 18.168,-51.95805 51.773,-89.25905 103.3,-109.64005 10.858,-4.2942 22.142,-7.1453 34.02,-6.9634 9.9907,0.15308 20.033,-0.63256 29.971,0.0966 54.496,3.9987 95.68,37.605 108.12,91.811 4.076,17.75405 5.2869,35.48605 4.398,54.38005 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1231"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m 300.20506,1627.141 c 13.567,-28.144 32.346,-50.872 59.887,-64.58 43.428,-21.614 85.613,-20.502 126.25,8.4982 23.424,16.714 36.826,39.732 46.403,65.772 4.0204,10.932 7.9345,21.912 7.5571,33.91 -0.0902,2.8691 1.6816,5.7491 1.9879,8.6877 0.71777,6.8887 2.2121,13.968 1.3169,20.694 -1.6601,12.473 -4.3237,24.872 -7.4395,37.079 -4.9044,19.215 -13.43,36.951 -24.635,53.272 -16.493,24.023 -37.16,43.406 -63.481,56.579 -12.972,6.4922 -26.504,10.941 -40.743,13.018 -11.321,1.6517 -22.396,0.03 -33.536,-3.1269 -39.371,-11.156 -66.054,-35.982 -81.483,-73.503 -8.4208,-20.478 -13.778,-41.758 -16.374,-63.703 -1.0917,-9.2269 -2.2838,-18.646 3.0723,-27.252 0.50358,-0.809 0.80103,-1.9124 0.7689,-2.8646 -0.77738,-23.046 10.349,-42.208 20.444,-62.482 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1232"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m 2883.7351,557.44095 c 2.5485,14.043 -0.7898,26.584 -4.1365,39.129 -1.5415,5.7796 -2.6047,11.723 -4.593,17.341 -11.059,31.249 -33.415,51.447 -63.638,63.345 -9.834,3.8716 -20.036,8.7379 -30.861,7.0025 -11.396,-1.8269 -22.756,-4.7903 -33.654,-8.6171 -22.475,-7.8919 -39.891,-23.295 -57.235,-39.149 -19.881,-18.173 -32.392,-40.36 -40.309,-65.51 -10.504,-33.373 -8.6064,-66.523 4.7361,-98.598 6.5962,-15.857 17.66,-28.616 32.948,-37.706 15.728,-9.3517 32.72,-14.613 50.375,-18.052 4.3454,-0.84643 9.2426,0.29749 13.743,1.2235 27.943,5.7506 52.26,18.729 74.866,36.017 22.472,17.185 38.061,38.906 47.286,65.242 4.2732,12.198 6.9187,24.967 10.473,38.332 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1233"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m 3315.6351,956.91095 c 22.787,5.0119 43.42,12.91 62.267,25.491 32.408,21.63405 54.795,50.53305 67.333,87.62505 6.784,20.069 7.7913,40.393 7.104,61.049 -0.1606,4.8289 -2.1899,9.6662 -3.7593,14.366 -9.3818,28.096 -27.618,49.179 -52.702,64.213 -19.106,11.451 -40.307,13.816 -61.8,9.4024 -24.391,-5.0083 -46.705,-14.899 -66.49,-30.624 -13.051,-10.373 -23.198,-22.957 -31.738,-36.849 -10.862,-17.671 -19.018,-36.66 -22.779,-57.214 -7.0744,-38.662 0.056,-74.18 24.968,-105.15005 4.4558,-5.5383 11.059,-9.4536 16.977,-13.69 15.221,-10.896 32.913,-15.48 50.889,-19.087 2.842,-0.57032 5.9404,0.1344 9.7297,0.46405 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1234"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m 1672.5351,652.48095 c -29.848,-0.72931 -56.012,-10.441 -78.875,-27.363 -32.836,-24.305 -49.058,-58.082 -45.766,-98.724 2.0525,-25.336 12.057,-48.892 28.967,-68.957 22.175,-26.312 50.171,-42.34 83.772,-48.602 16.505,-3.0758 32.574,0.15561 47.991,6.0706 16.875,6.4744 32.937,14.91 46.474,26.895 12.572,11.13 21.127,25.533 28.128,40.835 8.4133,18.39 11.704,37.875 8.8893,57.529 -2.5,17.459 -9.3778,34.025 -19.086,49.018 -23.486,36.273 -56.818,57.201 -100.49,63.298 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1235"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m 2272.0351,494.99095 c 0.1003,6.8868 -0.1856,12.912 0.3108,18.872 3.019,36.252 -11.678,65.825 -36.115,90.674 -18.028,18.333 -40.79,29.46 -65.822,36.073 -30.314,8.008 -56.927,-0.74365 -82.596,-16.131 -32.917,-19.733 -49.557,-50.005 -57.082,-86.392 -1.1382,-5.5037 -3.8636,-11.446 -2.75,-16.502 3.125,-14.189 6.6611,-28.523 12.213,-41.896 15.183,-36.569 42.844,-60.681 79.948,-73.207 44.17,-14.911 83.072,-4.9828 116.67,27.366 14.23,13.7 24.395,29.837 32.006,47.771 1.6587,3.9075 2.158,8.307 3.2159,13.372 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1236"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m 552.62506,976.02095 c 18.526,8.9499 31.076,22.855 39.573,40.43005 6.2274,12.881 12.432,25.887 12.319,40.772 -0.0146,1.9292 0.48065,4.1105 1.4536,5.7521 2.8398,4.7922 2.8779,9.3235 0.11212,14.15 -0.95648,1.669 -1.488,3.7838 -1.569,5.7219 -1.0396,24.877 -11.261,46.386 -24.873,66.448 -19.172,28.257 -42.662,51.64 -74.182,66.485 -33.918,15.975 -65.086,10.058 -93.973,-10.97 -14.945,-10.879 -22.826,-27.533 -28.116,-45.067 -6.3965,-21.202 -5.1826,-43.094 -3.1263,-64.525 1.5458,-16.11 8.2425,-31.53 15.599,-46.104 13.495,-26.735 33.404,-47.996 58.16,-64.65005 12.549,-8.4421 26.243,-14.382 41.469,-16.267 2.6187,-0.32416 5.2589,-0.96924 7.7298,-1.8926 6.182,-2.3106 11.952,-1.966 18.437,-0.1189 10.202,2.906 20.878,4.1511 30.986,9.8354 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1237"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m 1195.6351,411.05095 c 19.298,16.211 31.404,34.862 33.179,60.587 2.0077,29.093 -10.475,52.664 -25.22,75.152 -20.733,31.622 -49.908,53.544 -86.32,64.466 -30.903,9.2695 -61.776,8.9481 -91.56,-5.1626 -19.906,-9.4308 -31.93504,-25.61 -38.40004,-46.226 -4.7897,-15.275 -5.5456,-30.366 -0.1884,-46.025 6.1288,-17.914 10.126,-36.501 21.16604,-52.504 22.004,-31.896 51.037,-54.171 88.461,-64.583 34.598,-9.6262 67.906,-7.597 98.88,14.295 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m 1911.5351,199.31095 c -21.919,-9.8131 -34.718,-26.264 -40.456,-48.533 -0.9129,-3.542 -1.9837,-7.0524 -2.6973,-10.634 -0.5807,-2.9154 -1.5814,-6.1205 -0.9221,-8.8398 2.019,-8.3277 3.3392,-17.284 7.47,-24.553 11.543,-20.313997 28.266,-35.197997 51.261,-41.652997 4.6669,-1.3101 9.9126,-1.1237 14.845,-0.83335 30.516,1.7966 53.554,18.411 64.533,46.845997 11.796,30.552 8.311,30.134 -4.5068,55.229 -5.262,10.302 -11.585,20.098 -21.537,27.054 -18.542,12.959 -38.378,15.775 -59.755,8.8699 -2.5309,-0.8175 -5.0183,-1.7698 -8.2348,-2.9519 z",
    fill: "#ffffff",
    opacity: 0,
    id: "path1239"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1239"
  }, "\n@font-face {\n    font-family: 'Teachers';\n    src: url('data:font/ttf;charset=utf-8;base64,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') format('truetype'),\n        url('#Teachers-Regular') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n   ")), /*#__PURE__*/React.createElement("text", {
    className: "june-logo-text",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 2000,
      fontFamily: "Teachers",
      dominantBaseline: "middle",
      fill: "#0000ff"
    },
    dominantBaseline: "middle",
    x: 4269.6353,
    y: 2184.9409,
    id: "text1240"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 2000,
      fontFamily: "Teachers",
      InkscapeFontSpecification: "'Teachers, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    },
    id: "tspan1240"
  }, "June ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuneLogo);
export default __webpack_public_path__ + "static/media/june-logo.61700441b669830abf3f06e2e3497711.svg";
export { ForwardRef as ReactComponent };